module.exports = function() {
  !(function e(t, r, n) {
    function i(s, o) {
      if (!r[s]) {
        if (!t[s]) {
          var u = 'function' == typeof require && require
          if (!o && u) return u(s, !0)
          if (a) return a(s, !0)
          var c = new Error("Cannot find module '" + s + "'")
          throw ((c.code = 'MODULE_NOT_FOUND'), c)
        }
        var d = (r[s] = { exports: {} })
        t[s][0].call(
          d.exports,
          function(e) {
            var r = t[s][1][e]
            return i(r || e)
          },
          d,
          d.exports,
          e,
          t,
          r,
          n
        )
      }
      return r[s].exports
    }
    for (
      var a = 'function' == typeof require && require, s = 0;
      s < n.length;
      s++
    )
      i(n[s])
    return i
  })(
    {
      1: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e, t) {
              for (var s = [], o = 0; o < e.length; o++) {
                for (var l = !1, g = 0; g < c.htSlots.length; g++)
                  if (e[o].htSlotName === c.htSlots[g].getName()) {
                    l = !0
                    var m = { htSlot: c.htSlots[g], ref: '' }
                    e[o].hasOwnProperty('firstPartyData') &&
                      (m.firstPartyData = e[o].firstPartyData),
                      s.push(m)
                  }
                l ||
                  i.emit(
                    'error',
                    'unrecognized header tag slot name ' +
                      e[o].htSlotName +
                      ' in call to retrieveDemand'
                  )
              }
              if (0 === s.length)
                return (
                  i.emit(
                    'warning',
                    'no valid header tag slots found in call to retrieveDemand'
                  ),
                  { sessionId: '', promise: u.resolve({}) }
                )
              var y = r
              'undefined' !== d.getType(t) && t.hasOwnProperty('timeout')
                ? (y = t.timeout)
                : 'mobile' === c.DeviceTypeChecker.getDeviceType() && (y = n),
                (c.globalTimeout = y)
              var v = a.createTimer(y, !0)
              return (
                i.emit('hs_session_start', { sessionId: v }),
                a.addTimerCallback(v, function() {
                  i.emit('global_timeout_reached', { sessionId: v })
                }),
                {
                  promise: f._executeNext(v, s).then(function(e) {
                    i.emit('hs_session_end', { sessionId: v })
                    for (
                      var t = { slot: {}, page: [] }, r = 0;
                      r < e.length;
                      r++
                    )
                      if (
                        !e[r].pass &&
                        d.isObject(e[r].targeting) &&
                        !d.isEmpty(e[r].targeting)
                      )
                        if ('slot' === e[r].targetingType) {
                          var n = e[r].htSlot.getName()
                          t.slot.hasOwnProperty(n) || (t.slot[n] = []),
                            t.slot[n].push({
                              targeting: e[r].targeting,
                              price: e[r].price ? e[r].price : 0,
                              adm: e[r].adm ? e[r].adm : '',
                              size: e[r].size ? e[r].size : [],
                              partnerId: e[r].partnerId ? e[r].partnerId : '',
                              winNotice: e[r].winNotice
                                ? e[r].winNotice
                                : p.noOp
                            })
                        } else if ('page' === e[r].targetingType) {
                          var a = {
                            targeting: e[r].targeting,
                            partnerId: e[r].partnerId ? e[r].partnerId : ''
                          }
                          e.hasOwnProperty('price') && (a.price = e[r].price),
                            e.hasOwnProperty('adm') && (a.adm = e[r].adm),
                            t.page.push(a)
                        }
                    return t
                  }),
                  sessionId: v
                }
              )
            }
            var r,
              n,
              f = o()
            !(function() {
              ;(i = c.services.EventsService),
                (a = c.services.TimerService),
                (r = e.desktopGlobalTimeout),
                (n = e.mobileGlobalTimeout),
                'mobile' === c.DeviceTypeChecker.getDeviceType()
                  ? (c.globalTimeout = n)
                  : (c.globalTimeout = r),
                f._setDirectInterface('DirectBiddingLayer', {
                  retrieveDemand: t
                })
            })()
            var l = {}
            return s.derive(f, l)
          }
          var i,
            a,
            s = e(8),
            o = e(3),
            u = e(13),
            c = e(36),
            d = e(20),
            p = (e(21), e(19))
          t.exports = n
        },
        {}
      ],
      2: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e, t) {
              return (
                (_[e] = S.IN_PROGRESS),
                new u(function(r) {
                  t.instance
                    .retrieve()
                    .then(function() {
                      ;(_[e] = S.COMPLETE), r()
                    })
                    .catch(function(t) {
                      ;(_[e] = S.COMPLETE), r()
                    })
                })
              )
            }
            function r() {
              for (var e = [], r = u.defer(), n = Object.keys(b); n.length; ) {
                var i = d.randomSplice(n),
                  a = b[i]
                if (a.enabled)
                  try {
                    e.push(t(i, a))
                  } catch (e) {}
              }
              return (
                u.all(e).then(function() {
                  r.resolve()
                }),
                r
              )
            }
            function n() {
              for (var e in _)
                _.hasOwnProperty(e) &&
                  _[e] !== S.COMPLETE &&
                  i.emit('hs_identity_timeout', {
                    statsId: b[e].instance.getStatsId()
                  })
            }
            function l() {
              var e = {}
              for (var t in b)
                if (b.hasOwnProperty(t)) {
                  var r = b[t]
                  if (r.enabled) {
                    var n = r.instance.getResults()
                    n && (e[t] = { data: n })
                  }
                }
              return e
            }
            function g() {
              I === S.NOT_STARTED &&
                ((E = r()),
                (I = S.IN_PROGRESS),
                E.promise.then(function() {
                  n(), (I = S.COMPLETE)
                }),
                0 === w
                  ? E.resolve()
                  : T ||
                    (T = a.createTimer(w, !1, function() {
                      E.resolve()
                    })))
            }
            function m() {
              return I === S.NOT_STARTED
                ? u.resolve(null)
                : (I !== S.COMPLETE && T && a.startTimer(T),
                  E.promise.then(function() {
                    return l()
                  }))
            }
            function y(e, t) {
              return m().then(function(r) {
                if (r && !d.isEmpty(r))
                  for (var n = 0; n < t.length; n++) t[n].identityData = r
                return h._executeNext(e, t)
              })
            }
            function v() {
              var e = {}
              for (var t in b)
                if (b.hasOwnProperty(t)) {
                  var r = b[t]
                  if (r.enabled) {
                    var n = r.instance.getResults()
                    _[t] === S.COMPLETE
                      ? ((e[t] = n ? { data: n } : { data: {} }),
                        (e[t].responsePending = !1))
                      : (e[t] = { data: {}, responsePending: !0 })
                  }
                }
              return e
            }
            var h,
              b,
              I,
              _,
              w,
              T,
              E,
              S = { NOT_STARTED: 0, IN_PROGRESS: 1, COMPLETE: 2 }
            return (
              (function() {
                ;(i = c.services.EventsService),
                  (a = c.services.TimerService),
                  (h = o()),
                  (I = S.NOT_STARTED),
                  (_ = {}),
                  (b = e.partners),
                  (w = e.timeout),
                  i.emit('hs_define_identity_timeout', { timeout: w })
                for (var t = Object.keys(b), r = t.length - 1; r >= 0; r--) {
                  var n = d.randomSplice(t),
                    s = b[n]
                  if (s.enabled)
                    try {
                      var u = f[n]
                      if (
                        (d.isObject(u)
                          ? (s.instance = p(u, s.configs))
                          : (s.instance = u(s.configs)),
                        !s.instance)
                      ) {
                        s.enabled = !1
                        continue
                      }
                      _[n] = S.NOT_STARTED
                    } catch (e) {
                      s.enabled = !1
                    }
                }
                h._setDirectInterface('IdentityLayer', {
                  retrieve: g,
                  getResult: m,
                  getIdentityResults: v
                }),
                  h._setExecutor(y)
              })(),
              s.derive(h, { retrieve: g, getResult: m })
            )
          }
          var i,
            a,
            s = e(8),
            o = e(3),
            u = e(13),
            c = e(36),
            d = e(20),
            p = e(24),
            f = { AdserverOrgIp: e(23), LiveRampIp: e(25) }
          t.exports = n
        },
        {}
      ],
      3: [
        function(e, t, r) {
          'use strict'
          function n() {
            function e(e, t) {
              return i.resolve(t)
            }
            function t(e, t) {
              ;(u = {}), (u[e] = t)
            }
            function r(e) {
              c = e
            }
            function n() {
              return u
            }
            function a(e) {
              d = e
            }
            function s(e, t) {
              return d(e, t)
            }
            function o(e, t) {
              return i.resolve().then(function() {
                return c(e, t)
              })
            }
            var u, c, d
            return (
              (function() {
                ;(u = null), (c = e), (d = e)
              })(),
              {
                _setDirectInterface: t,
                _setExecutor: r,
                _executeNext: s,
                setNext: a,
                getDirectInterface: n,
                execute: o
              }
            )
          }
          var i = e(13)
          e(21)
          t.exports = n
        },
        {}
      ],
      4: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e) {
              var t = []
              for (var r in e)
                if (e.hasOwnProperty(r)) {
                  var n = e[r].priority
                  d.isInteger(n) || (n = o.DEFAULT_PARTNER_PRIORITY),
                    (t[n] = t[n] || []),
                    t[n].push(r)
                }
              var i = []
              return (
                t.forEach(function(e) {
                  d.shuffle(e),
                    e.forEach(function(e) {
                      i.push(e)
                    })
                }),
                i
              )
            }
            function r(e, t, r, n, i) {
              if (i && r.getPrefetchDisabled()) return []
              var a = n.slice(),
                s = [],
                o = r.retrieve(e, a),
                c = o.map(function(e) {
                  var t = u.defer()
                  return (
                    e
                      .then(function(e) {
                        t.resolve(e)
                      })
                      .catch(function(e) {
                        t.resolve([])
                      }),
                    t
                  )
                })
              return d.appendToArray(s, c), s
            }
            function n(e, n, i) {
              for (
                var a = { defers: [], promises: [] }, s = t(m), o = 0;
                o < s.length;
                o++
              ) {
                var u = s[o],
                  c = m[u]
                if (c.enabled)
                  try {
                    for (
                      var d = r(e, u, c.instance, n, i), p = 0;
                      p < d.length;
                      p++
                    )
                      a.defers.push(d[p]), a.promises.push(d[p].promise)
                  } catch (e) {}
              }
              return a
            }
            function f(e) {
              for (var t in e)
                if (e.hasOwnProperty(t) && y.hasOwnProperty(t))
                  for (var r = y[t], n = 0; n < r.length; n++) {
                    var i = r[n]
                    m.hasOwnProperty(i) && m[i].instance.setFirstPartyData(e[t])
                  }
            }
            function l(e, t) {
              var r = n(e, t)
              return (
                i.addTimerCallback(e, function() {
                  for (var e = 0; e < r.defers.length; e++)
                    r.defers[e].resolve([])
                }),
                u.all(r.promises).then(function(t) {
                  return i.clearTimer(e), t ? d.mergeArrays.apply(null, t) : []
                })
              )
            }
            var g,
              m,
              y = { rubicon: ['RubiconHtb', 'RubiconExtHtb'] }
            return (
              (function() {
                ;(i = c.services.TimerService), (g = s()), (m = e.partners)
                for (var r = {}, n = t(m), a = 0; a < n.length; a++) {
                  var o = n[a],
                    u = m[o]
                  if (u.enabled)
                    try {
                      if (((u.instance = p[o](u.configs, o)), !u.instance)) {
                        u.enabled = !1
                        continue
                      }
                      u.instance.getDirectInterface() &&
                        (r = d.mergeObjects(r, u.instance.getDirectInterface()))
                    } catch (e) {
                      u.enabled = !1
                    }
                }
                var y = { Partners: r, setFirstPartyData: f }
                g._setDirectInterface('PartnersLayer', y), g._setExecutor(l)
              })(),
              a.derive(g, {})
            )
          }
          var i,
            a = e(8),
            s = e(3),
            o = e(10),
            u = e(13),
            c = e(36),
            d = e(20),
            p = (e(21), { IndexExchangeHtb: e(26), TargetHtb: e(28) })
          t.exports = n
        },
        {}
      ],
      5: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(t) {
              return e.roundingType === n.RoundingTypes.FLOOR
                ? Math.floor(t)
                : t
            }
            function r(r) {
              var o = 0,
                u = 1,
                c = r.toString(),
                d = c.indexOf('.')
              if (
                (d > -1 &&
                  ((o = c.length - d - 1),
                  (c = c.slice(0, d) + c.slice(d + 1))),
                o >= a)
              )
                o -= a
              else {
                var p = a - o
                ;(o = 0), (c = i.padEnd(c, c.length + p, '0'))
              }
              c.length > 9 && ((o -= c.length - 9), (c = c.slice(0, 9))),
                (u = Math.pow(10, o)),
                (c = Number(c))
              var f = e.buckets.length
              if (c < e.floor * u) c = 0
              else if (c >= e.buckets[f - 1].max * u)
                c = e.buckets[f - 1].max * u
              else {
                for (
                  var l, g = e.floor, m = 0;
                  m < f && ((l = e.buckets[m]), !(c <= l.max * u));
                  m++
                )
                  g = l.max
                e.roundingType !== n.RoundingTypes.NONE &&
                  ((c -= g * u),
                  (c /= l.step * u),
                  (c = t(c)),
                  (c *= l.step * u),
                  (c += g * u))
              }
              ;(c = c.toString()), (o += s)
              var y = c.length - o
              y < 1 && ((c = i.padStart(c, c.length + (1 - y), '0')), (y = 1))
              var v = c.slice(0, y)
              return (
                0 !== e.outputPrecision &&
                  ((v = v + '.' + c.slice(y)),
                  e.outputPrecision > 0 &&
                    (v =
                      o < e.outputPrecision
                        ? i.padEnd(v, y + e.outputPrecision + 1, '0')
                        : v.slice(0, y + e.outputPrecision + 1))),
                v
              )
            }
            var a,
              s,
              o = { floor: 0, buckets: [{ max: 1 / 0, step: 1 }] }
            return (
              (function() {
                ;(a = Math.round(Math.log(e.bidUnitInCents) * Math.LOG10E)),
                  (s = Math.round(
                    Math.log(e.outputCentsDivisor) * Math.LOG10E
                  )),
                  (e.roundingType = n.RoundingTypes[e.roundingType])
                for (var t = ['floor', 'buckets'], r = 0; r < t.length; r++) {
                  var i = t[r]
                  e.hasOwnProperty(i) || (e[i] = o[i])
                }
              })(),
              { apply: r }
            )
          }
          var i = e(20)
          e(21)
          ;(n.RoundingTypes = { NONE: 0, FLOOR: 1 }), (t.exports = n)
        },
        {}
      ],
      6: [
        function(e, t, r) {
          'use strict'
          e(21)
          t.exports = (function() {
            function e(e, t) {
              return (
                (e = e || 'http:'),
                (t = t || 'https:'),
                'https:' === document.location.protocol ? t : e
              )
            }
            function t() {
              return ('CSS1Compat' === h.document.compatMode
                ? h.document.documentElement
                : h.document.body
              ).clientWidth
            }
            function r() {
              return ('CSS1Compat' === h.document.compatMode
                ? h.document.documentElement
                : h.document.body
              ).clientHeight
            }
            function n() {
              return h.screen.width
            }
            function i() {
              return h.screen.height
            }
            function a() {
              return document.referrer
            }
            function s() {
              return h.location.hostname
            }
            function o() {
              return navigator.userAgent
            }
            function u() {
              return (
                navigator.language ||
                navigator.browserLanguage ||
                navigator.userLanguage ||
                navigator.systemLanguage
              )
            }
            function c() {
              return h.location.pathname
            }
            function d() {
              try {
                return window.top === window.self
              } catch (e) {
                return !1
              }
            }
            function p() {
              return d() ? location.href : document.referrer || location.href
            }
            function f() {
              try {
                return (
                  localStorage.setItem('test', 'test'),
                  localStorage.removeItem('test'),
                  !0
                )
              } catch (e) {
                return !1
              }
            }
            function l(e, t, r, n) {
              try {
                for (var i, a = window, s = 0; ; )
                  if (!(r && s < r)) {
                    if (n && s > n) break
                    if (e && (i = e(a))) return i
                    var o
                    try {
                      o = a.frameElement
                    } catch (e) {
                      o = null
                    }
                    if (null === o) {
                      if (t && (i = t(a))) return i
                      break
                    }
                    ;(a = a.parent), s++
                  }
              } catch (e) {}
              return null
            }
            function g(e) {
              return l(function(t) {
                return t.hasOwnProperty(e) ? t[e] : null
              })
            }
            function m(e, t) {
              var r = t || h,
                n = r.document.createElement('iframe')
              return (
                e && (n.src = e),
                (n.width = 0),
                (n.height = 0),
                (n.scrolling = 'no'),
                (n.marginWidth = 0),
                (n.marginHeight = 0),
                (n.frameBorder = 0),
                n.setAttribute(
                  'style',
                  'border: 0px; vertical-align: bottom; visibility: hidden; display: none;'
                ),
                r.document.body.appendChild(n),
                n
              )
            }
            function y(e) {
              var t = e + '=',
                r = h.document.cookie.split(';')
              for (var n in r)
                if (r.hasOwnProperty(n)) {
                  for (var i = r[n]; ' ' === i.charAt(0); )
                    i = i.substring(1, i.length)
                  if (0 === i.indexOf(t)) return i.substring(t.length, i.length)
                }
              return null
            }
            function v() {
              var e = !1
              try {
                new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash') &&
                  (e = !0)
              } catch (t) {
                navigator.mimeTypes &&
                  void 0 !==
                    navigator.mimeTypes['application/x-shockwave-flash'] &&
                  navigator.mimeTypes['application/x-shockwave-flash']
                    .enabledPlugin &&
                  (e = !0)
              }
              return e
            }
            var h
            return (
              (function() {
                h = l(null, function(e) {
                  return e
                })
              })(),
              {
                topWindow: h,
                getProtocol: e,
                isLocalStorageSupported: f,
                getViewportWidth: t,
                getViewportHeight: r,
                isTopFrame: d,
                getScreenWidth: n,
                getScreenHeight: i,
                getReferrer: a,
                getPageUrl: p,
                getHostname: s,
                getUserAgent: o,
                getLanguage: u,
                getPathname: c,
                getNearestEntity: g,
                traverseContextTree: l,
                createHiddenIFrame: m,
                readCookie: y,
                isFlashSupported: v
              }
            )
          })()
        },
        {}
      ],
      7: [
        function(e, t, r) {
          'use strict'
          var n = e(6),
            i = e(20),
            a = e(19)
          t.exports = (function() {
            function e(e) {
              if (!s) return !1
              try {
                localStorage.removeItem(o + e)
              } catch (e) {
                return !1
              }
              return !0
            }
            function t(t) {
              if (!s) return null
              var r
              try {
                r = JSON.parse(localStorage.getItem(o + t))
              } catch (e) {
                return null
              }
              return null === r
                ? null
                : !r.e || r.e < a.now()
                ? (e(t), null)
                : i.isObject(r.d)
                ? r.d
                : null
            }
            function r(e, t, r) {
              if (!s) return !1
              r > u && (r = u)
              var n = a.now(),
                i = { t: n, d: t, e: n + r }
              try {
                localStorage.setItem(o + e, JSON.stringify(i))
              } catch (e) {
                return !1
              }
              return !0
            }
            var s,
              o = 'IXWRAPPER',
              u = 6048e5
            return (
              (function() {
                s = n.isLocalStorageSupported()
              })(),
              { deleteData: e, getData: t, setData: r }
            )
          })()
        },
        {}
      ],
      8: [
        function(e, t, r) {
          'use strict'
          e(21)
          t.exports = (function() {
            function e(e) {
              for (var t in e)
                e.hasOwnProperty(t) &&
                  '_' === t[0] &&
                  '__' !== t.slice(0, 2) &&
                  delete e[t]
              return e
            }
            function t(t, r) {
              var n,
                i = {}
              for (n in t) t.hasOwnProperty(n) && (i[n] = t[n])
              for (n in r) r.hasOwnProperty(n) && (i[n] = r[n])
              return e(i)
            }
            return { derive: t }
          })()
        },
        {}
      ],
      9: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e) {
              if (i.isFunction(e))
                try {
                  e()
                } catch (e) {}
            }
            return (
              (function() {
                if (i.isArray(e))
                  for (var t = 0; t < e.length; t++)
                    try {
                      e[t]()
                    } catch (e) {}
              })(),
              { push: t }
            )
          }
          var i = e(20)
          t.exports = n
        },
        {}
      ],
      10: [
        function(e, t, r) {
          'use strict'
          var n = {
            DEFAULT_UID_LENGTH: 8,
            MIN_BANNER_DIMENSION: 1,
            MIN_BID_FLOOR: 0,
            MIN_SITE_ID: 0,
            DEFAULT_UID_CHARSET: 'ALPHANUM',
            SESSION_ID_LENGTH: 8,
            PUBKIT_AD_ID_LENGTH: 16,
            RENDER_SERVICE_EXPIRY_SWEEP_TIMER: 3e4,
            DEFAULT_PARTNER_PRIORITY: 1,
            LineItemTypes: { ID_AND_SIZE: 1, ID_AND_PRICE: 2, CUSTOM: 3 },
            DeviceTypeMethods: { USER_AGENT: 1, REFERENCE: 2, SIZE_MAPPING: 3 },
            RequestArchitectures: { MRA: 1, SRA: 2 },
            InitialLoadStates: { DISABLED: 1, ENABLED: 2 },
            MediationLevels: { NONE: 1, HT_SLOT: 2, PARTNER: 3 }
          }
          t.exports = n
        },
        {}
      ],
      11: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t() {
              return o.mobile()
                ? n.DeviceTypes.MOBILE
                : (o.tablet(), n.DeviceTypes.DESKTOP)
            }
            function r() {
              var t
              try {
                t = eval(e.configs.reference)
              } catch (e) {
                throw s(
                  'INTERNAL_ERROR',
                  'DeviceTypeChecker: could not eval() `reference`.'
                )
              }
              if (!a.isFunction(t)) {
                if (a.isString(t)) return t
                throw s(
                  'INVALID_TYPE',
                  'DeviceTypeChecker: `reference` must refer to a function or a string'
                )
              }
              try {
                return t()
              } catch (e) {
                throw s(
                  'INTERNAL_ERROR',
                  'DeviceTypeChecker: could not execute `reference` function.'
                )
              }
            }
            function u() {
              switch (c) {
                case i.DeviceTypeMethods.USER_AGENT:
                  return t()
                case i.DeviceTypeMethods.REFERENCE:
                  return r()
                default:
                  return t()
              }
            }
            var c
            return (
              (function() {
                c =
                  i.DeviceTypeMethods[e.method] ||
                  i.DeviceTypeMethods.USER_AGENT
              })(),
              { getDeviceType: u }
            )
          }
          var i = e(10),
            a = e(20),
            s = e(21),
            o = e(12)
          ;(n.isValidDeviceType = function(e) {
            for (var t in n.DeviceTypes)
              if (
                n.DeviceTypes.hasOwnProperty(t) &&
                'TABLET' !== t &&
                e === n.DeviceTypes[t]
              )
                return !0
            return !1
          }),
            (n.DeviceTypes = {
              DESKTOP: 'desktop',
              MOBILE: 'mobile',
              TABLET: 'tablet'
            }),
            (t.exports = n)
        },
        {}
      ],
      12: [
        function(e, t, r) {
          'use strict'
          var n, i, a
          ;(n = {}),
            (a = window.navigator.userAgent.toLowerCase()),
            (n.ios = function() {
              return n.iphone() || n.ipod() || n.ipad()
            }),
            (n.iphone = function() {
              return !n.windows() && i('iphone')
            }),
            (n.ipod = function() {
              return i('ipod')
            }),
            (n.ipad = function() {
              return i('ipad')
            }),
            (n.android = function() {
              return !n.windows() && i('android')
            }),
            (n.androidPhone = function() {
              return n.android() && i('mobile')
            }),
            (n.androidTablet = function() {
              return n.android() && !i('mobile')
            }),
            (n.blackberry = function() {
              return i('blackberry') || i('bb10') || i('rim')
            }),
            (n.blackberryPhone = function() {
              return n.blackberry() && !i('tablet')
            }),
            (n.blackberryTablet = function() {
              return n.blackberry() && i('tablet')
            }),
            (n.windows = function() {
              return i('windows')
            }),
            (n.windowsPhone = function() {
              return n.windows() && i('phone')
            }),
            (n.windowsTablet = function() {
              return n.windows() && i('touch') && !n.windowsPhone()
            }),
            (n.fxos = function() {
              return (i('(mobile;') || i('(tablet;')) && i('; rv:')
            }),
            (n.fxosPhone = function() {
              return n.fxos() && i('mobile')
            }),
            (n.fxosTablet = function() {
              return n.fxos() && i('tablet')
            }),
            (n.meego = function() {
              return i('meego')
            }),
            (n.mobile = function() {
              return (
                n.androidPhone() ||
                n.iphone() ||
                n.ipod() ||
                n.windowsPhone() ||
                n.blackberryPhone() ||
                n.fxosPhone() ||
                n.meego()
              )
            }),
            (n.tablet = function() {
              return (
                n.ipad() ||
                n.androidTablet() ||
                n.blackberryTablet() ||
                n.windowsTablet() ||
                n.fxosTablet()
              )
            }),
            (n.desktop = function() {
              return !n.tablet() && !n.mobile()
            }),
            (i = function(e) {
              return -1 !== a.indexOf(e)
            }),
            (t.exports = n)
        },
        {}
      ],
      13: [
        function(e, t, r) {
          function n() {}
          function i(e) {
            if ('object' != typeof this)
              throw new TypeError('Promises must be constructed via new')
            if ('function' != typeof e) throw new TypeError('not a function')
            ;(this._state = 0),
              (this._handled = !1),
              (this._value = void 0),
              (this._deferreds = []),
              d(e, this)
          }
          function a(e, t) {
            for (; 3 === e._state; ) e = e._value
            if (0 === e._state) return void e._deferreds.push(t)
            e._handled = !0
            var r = 1 === e._state ? t.onFulfilled : t.onRejected
            if (null === r)
              return void (1 === e._state ? s : o)(t.promise, e._value)
            var n
            try {
              n = r(e._value)
            } catch (e) {
              return void o(t.promise, e)
            }
            s(t.promise, n)
          }
          function s(e, t) {
            try {
              if (t === e)
                throw new TypeError('A promise cannot be resolved with itself.')
              if (t && ('object' == typeof t || 'function' == typeof t)) {
                var r = t.then
                if (t instanceof i)
                  return (e._state = 3), (e._value = t), void u(e)
                if ('function' == typeof r) return void d(bind(r, t), e)
              }
              ;(e._state = 1), (e._value = t), u(e)
            } catch (t) {
              o(e, t)
            }
          }
          function o(e, t) {
            ;(e._state = 2), (e._value = t), u(e)
          }
          function u(e) {
            for (var t = 0, r = e._deferreds.length; t < r; t++)
              a(e, e._deferreds[t])
            e._deferreds = null
          }
          function c(e, t, r) {
            ;(this.onFulfilled = 'function' == typeof e ? e : null),
              (this.onRejected = 'function' == typeof t ? t : null),
              (this.promise = r)
          }
          function d(e, t) {
            var r = !1
            try {
              e(
                function(e) {
                  r || ((r = !0), s(t, e))
                },
                function(e) {
                  r || ((r = !0), o(t, e))
                }
              )
            } catch (e) {
              if (r) return
              ;(r = !0), o(t, e)
            }
          }
          ;(i.prototype.catch = function(e) {
            return this.then(null, e)
          }),
            (i.prototype.then = function(e, t) {
              var r = new this.constructor(n)
              return a(this, new c(e, t, r)), r
            }),
            (i.all = function(e) {
              var t = Array.prototype.slice.call(e)
              return new i(function(e, r) {
                function n(a, s) {
                  try {
                    if (s && ('object' == typeof s || 'function' == typeof s)) {
                      var o = s.then
                      if ('function' == typeof o)
                        return void o.call(
                          s,
                          function(e) {
                            n(a, e)
                          },
                          r
                        )
                    }
                    ;(t[a] = s), 0 == --i && e(t)
                  } catch (e) {
                    r(e)
                  }
                }
                if (0 === t.length) return e([])
                for (var i = t.length, a = 0; a < t.length; a++) n(a, t[a])
              })
            }),
            (i.resolve = function(e) {
              return e && 'object' == typeof e && e.constructor === i
                ? e
                : new i(function(t) {
                    t(e)
                  })
            }),
            (i.reject = function(e) {
              return new i(function(t, r) {
                r(e)
              })
            }),
            (i.defer = function() {
              var e = {}
              return (
                (e.promise = new i(function(t, r) {
                  ;(e.resolve = t), (e.reject = r)
                })),
                e
              )
            }),
            (t.exports = i)
        },
        {}
      ],
      14: [
        function(e, t, r) {
          'use strict'
          t.exports = (function(e) {
            e = e.toLowerCase()
            var t =
                /(edge)\/([\w.]+)/.exec(e) ||
                /(opr)[\/]([\w.]+)/.exec(e) ||
                /(chrome)[ \/]([\w.]+)/.exec(e) ||
                /(iemobile)[\/]([\w.]+)/.exec(e) ||
                /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(
                  e
                ) ||
                /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(
                  e
                ) ||
                /(webkit)[ \/]([\w.]+)/.exec(e) ||
                /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(e) ||
                /(msie) ([\w.]+)/.exec(e) ||
                (e.indexOf('trident') >= 0 && /(rv)(?::| )([\w.]+)/.exec(e)) ||
                (e.indexOf('compatible') < 0 &&
                  /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(e)) ||
                [],
              r = {},
              n = {
                browser: t[5] || t[3] || t[1] || '',
                version: t[2] || t[4] || '0',
                versionNumber: t[4] || t[2] || '0'
              }
            if (
              (n.browser &&
                ((r[n.browser] = !0),
                (r.version = n.version),
                (r.versionNumber = parseInt(n.versionNumber, 10))),
              r.rv || r.iemobile)
            ) {
              ;(n.browser = 'msie'), (r.msie = !0)
            }
            if (r.edge) {
              delete r.edge
              ;(n.browser = 'msedge'), (r.msedge = !0)
            }
            if (r.opr) {
              ;(n.browser = 'opera'), (r.opera = !0)
            }
            if (r.safari && r.android) {
              ;(n.browser = 'android'), (r.android = !0)
            }
            if (r.safari && r.kindle) {
              ;(n.browser = 'kindle'), (r.kindle = !0)
            }
            if (r.safari && r.silk) {
              ;(n.browser = 'silk'), (r.silk = !0)
            }
            return (r.name = n.browser), r
          })(window.navigator.userAgent)
        },
        {}
      ],
      15: [
        function(e, t, r) {
          'use strict'
          function n(e, t) {
            function r(e, t) {
              return Number(e) - Number(t)
            }
            function n() {
              return p
            }
            function i() {
              return f
            }
            function a() {
              return l
            }
            function s() {
              return g
            }
            function o(e, t) {
              var n,
                i,
                a,
                s,
                o = []
              n = Object.keys(m).sort(r)
              for (var u = n.length - 1; u >= 0; u--)
                if (((a = n[u]), !(Number(a) > e))) {
                  i = Object.keys(m[a]).sort(r)
                  for (var c = i.length - 1; c >= 0; c--)
                    if (((s = i[c]), !(Number(s) > t))) {
                      o = m[a][s]
                      break
                    }
                  if (o.length > 0) break
                }
              return o
            }
            function u() {
              return y
            }
            function c() {
              return v
            }
            function d() {
              return h
            }
            var p, f, l, g, m, y, v, h
            return (
              (function() {
                if (
                  ((p = e),
                  (f = t.id),
                  (l = null),
                  (g = null),
                  (m = null),
                  (y = null),
                  (v = null),
                  (h = null),
                  t.hasOwnProperty('divId') && (l = RegExp(t.divId)),
                  t.hasOwnProperty('adUnitPath') && (g = RegExp(t.adUnitPath)),
                  t.hasOwnProperty('sizeMapping'))
                ) {
                  var r,
                    n,
                    i,
                    a = /^(\d+)x(\d+)$/
                  m = {}
                  for (var s in t.sizeMapping)
                    t.sizeMapping.hasOwnProperty(s) &&
                      ((r = a.exec(s)),
                      (n = r[1]),
                      (i = r[2]),
                      m.hasOwnProperty(n) || (m[n] = {}),
                      (m[n][i] = t.sizeMapping[s]))
                }
                t.hasOwnProperty('targeting') && (y = t.targeting),
                  t.hasOwnProperty('deviceType') && (v = t.deviceType),
                  t.hasOwnProperty('position') && (h = t.position),
                  (t = void 0)
              })(),
              {
                getName: n,
                getId: i,
                getDivId: a,
                getAdUnitPath: s,
                getSizes: o,
                getTargeting: u,
                getDeviceType: c,
                getPosition: d
              }
            )
          }
          e(21)
          t.exports = n
        },
        {}
      ],
      16: [
        function(e, t, r) {
          'use strict'
          var n = e(36),
            i = e(19),
            a = e(20),
            s = e(21),
            o = e(14)
          t.exports = (function() {
            function e() {
              return p
            }
            function t(e) {
              var t = ''
              for (var r in e)
                if (e.hasOwnProperty(r))
                  if (a.isObject(e[r]))
                    for (var n in e[r])
                      e[r].hasOwnProperty(n) &&
                        (t +=
                          r +
                          '%5B' +
                          n +
                          '%5D=' +
                          encodeURIComponent(e[r][n]) +
                          '&')
                  else if (a.isArray(e[r]))
                    for (var i = 0; i < e[r].length; i++)
                      t += r + '%5B%5D=' + encodeURIComponent(e[r][i]) + '&'
                  else t += r + '=' + encodeURIComponent(e[r]) + '&'
              return t.slice(0, -1)
            }
            function r(e, r, n) {
              return (
                '/' !== e[e.length - 1] && r && (e += '/'),
                (r = r || []),
                a.isObject(n) && (n = t(n)),
                (n = n ? '?' + n : ''),
                e + r.join('/') + n
              )
            }
            function u(e) {
              var s,
                u = null,
                c = e.scope || window
              if (e.useImgTag) s = c.document.createElement('img')
              else {
                ;(s = c.document.createElement('script')),
                  (s.type = 'text/javascript')
                var d = !0
                e.hasOwnProperty('async') && (d = e.async), (s.async = d)
              }
              var p = e.url
              if (e.data) {
                var f
                ;(f = a.isString(e.data) ? e.data : t(e.data)),
                  (p = r(e.url, null, f))
              }
              var l,
                g = !1,
                m = function() {
                  try {
                    if (g) return
                    ;(g = !0),
                      e.onTimeout && e.onTimeout(),
                      e.useImgTag ||
                        e.continueAfterTimeout ||
                        s.parentNode.removeChild(s)
                  } catch (e) {}
                }
              e.globalTimeout &&
                n.services.TimerService.addTimerCallback(e.sessionId, m),
                e.timeout && (l = setTimeout(m, e.timeout))
              var y = function() {
                try {
                  if (g) {
                    if (!e.continueAfterTimeout) return
                  } else clearTimeout(l)
                  e.onSuccess && e.onSuccess(null, i.now(), g),
                    (g = !0),
                    e.useImgTag || s.parentNode.removeChild(s)
                } catch (e) {}
              }
              null === s.onload
                ? (s.onload = y)
                : (s.onreadystatechange = function() {
                    ;('loaded' !== s.readyState &&
                      'complete' !== s.readyState) ||
                      ((s.onreadystatechange = null), y())
                  })
              var v = function() {
                try {
                  if (g) {
                    if (!e.continueAfterTimeout) return
                  } else clearTimeout(l), (g = !0)
                  e.onFailure && e.onFailure(),
                    e.useImgTag || s.parentNode.removeChild(s)
                } catch (e) {}
              }
              if (((s.onerror = v), (u = i.now()), (s.src = p), !e.useImgTag)) {
                var h = c.document.getElementsByTagName('script')[0]
                h
                  ? h.parentNode.insertBefore(s, h)
                  : o.msie || o.msedge || o.mozilla
                  ? (c.onload = function() {
                      c.document.body.appendChild(s)
                    })
                  : c.document.body.appendChild(s)
              }
              return u
            }
            function c(o) {
              if (!e()) {
                if (o.jsonp && 'GET' === o.method) return u(o)
                throw s(
                  'INTERNAL_ERROR',
                  'XHR is not supported in this browser.'
                )
              }
              var c = null,
                d = o.scope || window,
                p = new d.XMLHttpRequest(),
                f = o.url,
                l = null
              if (o.data)
                if ('GET' === o.method) {
                  var g
                  ;(g = a.isString(o.data) ? o.data : t(o.data)),
                    (f = r(o.url, null, g))
                } else
                  'POST' === o.method &&
                    (l = a.isString(o.data) ? o.data : JSON.stringify(o.data))
              var m = !0
              o.hasOwnProperty('async') && (m = o.async), p.open(o.method, f, m)
              var y = 'application/x-www-form-urlencoded; charset=UTF-8'
              if (
                (void 0 !== o.contentType && (y = o.contentType),
                y && p.setRequestHeader('Content-Type', y),
                o.headers)
              ) {
                o.headers.hasOwnProperty('X-Request-With') ||
                  p.setRequestHeader('X-Request-With', 'XMLHttpRequest')
                for (var v in o.headers)
                  o.headers.hasOwnProperty(v) &&
                    p.setRequestHeader(v, o.headers[v])
              }
              o.withCredentials && (p.withCredentials = !0)
              var h,
                b = !1,
                I = function() {
                  try {
                    if (b) return
                    ;(b = !0), o.onTimeout && o.onTimeout()
                  } catch (e) {}
                }
              return (
                o.globalTimeout &&
                  n.services.TimerService.addTimerCallback(o.sessionId, I),
                o.timeout &&
                  (o.continueAfterTimeout
                    ? (h = setTimeout(I, o.timeout))
                    : ((p.timeout = o.timeout), (p.ontimeout = I))),
                (o.onSuccess || o.onFailure) &&
                  (p.onreadystatechange = function() {
                    if (4 === p.readyState) {
                      if (b) {
                        if (!o.continueAfterTimeout) return
                      } else clearTimeout(h), (p.ontimeout = null)
                      if (200 === p.status) {
                        if (o.onSuccess)
                          try {
                            o.onSuccess(p.responseText, i.now(), b)
                          } catch (e) {}
                      } else if (o.onFailure)
                        try {
                          o.onFailure(p.status)
                        } catch (e) {}
                      b = !0
                    }
                  }),
                (c = i.now()),
                p.send(l),
                c
              )
            }
            function d(e) {
              return (e.useImgTag = !0), u(e)
            }
            var p
            return (
              (function() {
                p =
                  window.XMLHttpRequest &&
                  'string' == typeof new XMLHttpRequest().responseType
              })(),
              {
                ajax: c,
                jsonp: u,
                img: d,
                buildUrl: r,
                objToQueryString: t,
                isXhrSupported: e
              }
            )
          })()
        },
        {}
      ],
      17: [
        function(e, t, r) {
          'use strict'
          var n = (e(10), e(19)),
            i = e(21)
          t.exports = (function() {
            function e() {
              if (!(this instanceof e)) return new e()
              ;(this.__bidRequest = {
                id: Number(n.generateUniqueId(8, 'NUM')),
                site: { page: '' },
                imp: []
              }),
                (this.__impCount = 0)
            }
            function t(e) {
              if (!(this instanceof t)) return new t(e)
              try {
                this.__bidResponse = e
              } catch (e) {
                throw i('INTERNAL_ERROR', 'cannot parse `bidResponse`')
              }
            }
            return (
              (e.prototype.setPage = function(e) {
                this.__bidRequest.site.page = e
              }),
              (e.prototype.setRef = function(e) {
                this.__bidRequest.site.ref = e
              }),
              (e.prototype.getId = function() {
                return this.__bidRequest.id
              }),
              (e.prototype.addImp = function(e, t, r, n) {
                var i = String(++this.__impCount)
                return (
                  this.__bidRequest.imp.push({
                    banner: e,
                    ext: t,
                    id: i,
                    bidfloor: r,
                    bidfloorcur: n
                  }),
                  i
                )
              }),
              (e.prototype.addUserEid = function(e) {
                ;(this.__bidRequest.user = this.__bidRequest.user || {}),
                  (this.__bidRequest.user.eids =
                    this.__bidRequest.user.eids || []),
                  this.__bidRequest.user.eids.push(e)
              }),
              (e.prototype.setGdprConsent = function(e, t) {
                ;(this.__bidRequest.regs = this.__bidRequest.regs || {}),
                  (this.__bidRequest.regs.ext =
                    this.__bidRequest.regs.ext || {}),
                  (this.__bidRequest.regs.ext.gdpr = e ? 1 : 0),
                  (this.__bidRequest.user = this.__bidRequest.user || {}),
                  (this.__bidRequest.user.ext =
                    this.__bidRequest.user.ext || {}),
                  (this.__bidRequest.user.ext.consent = t || '')
              }),
              (e.prototype.setExt = function(e) {
                this.__bidRequest.ext = e
              }),
              (e.prototype.stringify = function() {
                return JSON.stringify(this.__bidRequest)
              }),
              (t.prototype.__parseBid = function(e, t) {
                var r = {}
                e.hasOwnProperty('impid') && (r.impid = e.impid),
                  e.hasOwnProperty('price') && (r.price = e.price),
                  e.hasOwnProperty('adm') && (r.adm = e.adm),
                  e.hasOwnProperty('ext') && (r.ext = e.ext),
                  e.hasOwnProperty('dealid') && (r.dealid = e.dealid),
                  e.hasOwnProperty('nurl') && (r.nurl = e.nurl),
                  e.hasOwnProperty('nbr') && (r.nbr = e.nbr),
                  e.hasOwnProperty('w') && (r.w = e.w),
                  e.hasOwnProperty('h') && (r.h = e.h),
                  t.push(r)
              }),
              (t.prototype.getId = function() {
                return this.__bidResponse.id
              }),
              (t.prototype.getCur = function() {
                return this.__bidResponse.cur || 'USD'
              }),
              (t.prototype.getExt = function() {
                return this.__bidResponse.ext
              }),
              (t.prototype.getBids = function() {
                var e,
                  t,
                  r = []
                if (!this.__bidResponse.hasOwnProperty('seatbid')) return r
                t = this.__bidResponse.seatbid
                for (var n = 0; n < t.length; n++)
                  if (t[n].hasOwnProperty('bid')) {
                    e = t[n].bid
                    for (var i = 0; i < e.length; i++) this.__parseBid(e[i], r)
                  }
                return r
              }),
              { BidRequest: e, BidResponse: t }
            )
          })()
        },
        {}
      ],
      18: [
        function(e, t, r) {
          'use strict'
          var n = e(20)
          t.exports = (function() {
            function e(e) {
              return s[e]
            }
            function t(e) {
              return !(!n.isArray(e, 'number') || 2 !== e.length)
            }
            function r(e) {
              if (t(e)) return !0
              if (!n.isArray(e, 'array')) return !1
              for (var r = 0; r < e.length; r++) if (!t(e[r])) return !1
              return !0
            }
            function i(t, r, i) {
              ;(r = r || ','), (i = i || 'x')
              var a = ''
              if (n.isArray(t, 'array'))
                for (var s = 0; s < t.length; s++)
                  a += e(t[s]) ? t[s] : t[s][0] + i + t[s][1] + r
              else e(t) ? (a += t + r) : (a += t[0] + i + t[1] + r)
              return a.slice(0, -1)
            }
            function a(t, r, n) {
              ;(r = r || ','), (n = n || 'x')
              for (var i = [], a = t.split(r), s = 0; s < a.length; s++)
                if (e(a[s])) i.push(a[s])
                else {
                  var o = a[s].split(n)
                  i.push([Number(o[0]), Number(o[1])])
                }
              return i
            }
            var s = { native: !0, fullwidth: !0 }
            return {
              arrayToString: i,
              stringToArray: a,
              isSpecialSize: e,
              isSize: t,
              isSizes: r
            }
          })()
        },
        {}
      ],
      19: [
        function(e, t, r) {
          'use strict'
          var n = e(10)
          e(21)
          t.exports = (function() {
            function e(e, t) {
              e.open('text/html', 'replace'), e.write(t), e.close()
            }
            function t(e, t) {
              ;(e = e || n.DEFAULT_UID_LENGTH), (t = t || n.DEFAULT_UID_CHARSET)
              for (var r = '', i = 0; i < e; i++)
                r += u[t].charAt(Math.floor(Math.random() * u[t].length))
              return r
            }
            function r() {
              return (
                t(8, 'HEX') +
                '-' +
                t(4, 'HEX') +
                '-4' +
                t(3, 'HEX') +
                '-' +
                '89ab'.charAt(Math.floor(4 * Math.random())) +
                t(3, 'HEX') +
                '-' +
                t(8, 'HEX')
              )
            }
            function i() {
              return new Date().getTime()
            }
            function a() {
              return o.getTimezoneOffset()
            }
            function s() {}
            var o,
              u = {
                ALPHANUM:
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
                ALPHA: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
                ALPHA_UPPER: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
                ALPHA_LOWER: 'abcdefghijklmnopqrstuvwxyz',
                HEX: '0123456789abcdef',
                NUM: '0123456789'
              }
            return (
              (function() {
                o = new Date()
              })(),
              {
                UidCharacterSets: u,
                generateUniqueId: t,
                generateUuid: r,
                now: i,
                getTimezoneOffset: a,
                documentWrite: e,
                noOp: s
              }
            )
          })()
        },
        {}
      ],
      20: [
        function(e, t, r) {
          'use strict'
          var n = e(21)
          t.exports = (function() {
            function e(e) {
              return void 0 === e
                ? 'undefined'
                : {}.toString
                    .call(e)
                    .match(P)[1]
                    .toLowerCase()
            }
            function t(t) {
              return 'string' === e(t)
            }
            function r(t) {
              return 'number' === e(t) && !isNaN(t)
            }
            function i(t) {
              return (
                'number' === e(t) || ('string' === e(t) && !isNaN(Number(t)))
              )
            }
            function a(e) {
              return r(e) && e % 1 == 0
            }
            function s(t) {
              return 'function' === e(t)
            }
            function o(t) {
              return 'boolean' === e(t)
            }
            function u(t) {
              return 'object' === e(t)
            }
            function c(t) {
              return 'regexp' === e(t)
            }
            function d(e, t) {
              var r = e.indexOf(t)
              r > -1 && e.splice(r, 1)
            }
            function p(r, i, a) {
              if ('array' !== e(r)) return !1
              if (void 0 !== i) {
                if (!t(i)) throw n('INVALID_TYPE', '`type` must be a string')
                if ('class' === i) {
                  if (!t(a))
                    throw n('INVALID_TYPE', '`className` must be a string')
                  for (var s = 0; s < r.length; s++)
                    if ('object' != typeof r[s] || r[s].__type__ !== a)
                      return !1
                } else
                  for (var o = 0; o < r.length; o++)
                    if (e(r[o]) !== i) return !1
              }
              return !0
            }
            function f(e) {
              return e.length
                ? e.splice(Math.floor(Math.random() * e.length), 1)[0]
                : null
            }
            function l(e) {
              var t, r, n
              for (n = e.length - 1; n > 0; n--)
                (t = Math.floor(Math.random() * (n + 1))),
                  (r = e[n]),
                  (e[n] = e[t]),
                  (e[t] = r)
              return e
            }
            function g(e) {
              return JSON.parse(JSON.stringify(e))
            }
            function m() {
              for (
                var e = Array.prototype.slice.call(arguments), t = {}, r = 0;
                r < e.length;
                r++
              )
                for (var n in e[r]) e[r].hasOwnProperty(n) && (t[n] = e[r][n])
              return t
            }
            function y() {
              for (
                var e = Array.prototype.slice.call(arguments), t = [], r = 0;
                r < e.length;
                r++
              )
                for (var n = 0; n < e[r].length; n++) t.push(e[r][n])
              return t
            }
            function v(e) {
              if (t(e)) {
                if ('' !== e) return !1
              } else if (u(e)) {
                for (var r in e) if (e.hasOwnProperty(r)) return !1
              } else {
                if (!p(e))
                  throw n(
                    'INVALID_TYPE',
                    '`entity` must be either a string, object, or an array'
                  )
                if (e.length) return !1
              }
              return !0
            }
            function h(e, t, r) {
              void 0 === r && (r = O)
              for (var n = 0; n < e.length; n++) {
                for (
                  var i = !1, a = 0;
                  a < t.length && !(i = r(e[n], t[a]));
                  a++
                );
                if (!i) return !1
              }
              return !0
            }
            function b(e, t, r, n) {
              return (
                (t = t || []),
                (n = n || null),
                (r = r || 'Error occurred while calling function.'),
                function() {
                  try {
                    e.apply(n, t)
                  } catch (e) {}
                }
              )
            }
            function I(e, t) {
              var r = '' + e
              if (((t = +t), t != t && (t = 0), t < 0))
                throw new RangeError('repeat count must be non-negative')
              if (t == 1 / 0)
                throw new RangeError('repeat count must be less than infinity')
              if (((t = Math.floor(t)), 0 == r.length || 0 == t)) return ''
              if (r.length * t >= 1 << 28)
                throw new RangeError(
                  'repeat count must not overflow maximum string size'
                )
              for (var n = '', i = 0; i < t; i++) n += r
              return n
            }
            function _(e, t, r) {
              return (
                (t >>= 0),
                (r = String(r || ' ')),
                e.length > t
                  ? String(e)
                  : ((t -= e.length),
                    t > r.length && (r += I(r, t / r.length)),
                    r.slice(0, t) + String(e))
              )
            }
            function w(e, t, r) {
              return (
                (t >>= 0),
                (r = String(r || ' ')),
                e.length > t
                  ? String(e)
                  : ((t -= e.length),
                    t > r.length && (r += I(r, t / r.length)),
                    String(e) + r.slice(0, t))
              )
            }
            function T(e, t) {
              t = t || null
              try {
                return eval.call(t, e)
              } catch (e) {}
              return null
            }
            function E(e, t, r) {
              r = r || null
              try {
                return eval.call(r, e + '(' + t.join() + ')')
              } catch (e) {}
              return null
            }
            function S() {
              for (
                var e = Array.prototype.slice.call(arguments), t = e[0], r = 1;
                r < e.length;
                r++
              )
                Array.prototype.push.apply(t, e[r])
              return t
            }
            var P = /\s([a-zA-Z]+)/,
              O = function(e, t) {
                return e === t
              }
            return {
              randomSplice: f,
              shuffle: l,
              deepCopy: g,
              mergeObjects: m,
              mergeArrays: y,
              isArray: p,
              isEmpty: v,
              isInteger: a,
              isString: t,
              isNumeric: i,
              isRegex: c,
              isNumber: r,
              isBoolean: o,
              isFunction: s,
              isObject: u,
              isArraySubset: h,
              getType: e,
              tryCatchWrapper: b,
              arrayDelete: d,
              repeatString: I,
              padStart: _,
              padEnd: w,
              evalVariable: T,
              evalFunction: E,
              appendToArray: S
            }
          })()
        },
        {}
      ],
      21: [
        function(e, t, r) {
          'use strict'
          function n(e, t) {
            return new Error(e + ': ' + t)
          }
          ;(n.ErrorTokens = {
            MISSING_ARGUMENT: 1,
            INVALID_TYPE: 2,
            INVALID_VALUE: 3,
            MISSING_PROPERTY: 4,
            NUMBER_OUT_OF_RANGE: 5,
            EMPTY_ENTITY: 6,
            INTERNAL_ERROR: 7,
            DUPLICATE_ENTITY: 8,
            INVALID_ARGUMENT: 9,
            INVALID_CONFIG: 10
          }),
            (t.exports = n)
        },
        {}
      ],
      22: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t() {
              return r
            }
            var r
            return (
              (function() {
                s.DeviceTypeChecker = i(e.DeviceTypeChecker)
                for (var t in e.htSlots)
                  if (e.htSlots.hasOwnProperty(t)) {
                    var n = a(t, e.htSlots[t])
                    s.htSlots.push(n), (s.htSlotsMap[t] = n)
                  }
                r = { Services: {}, Layers: {} }
                for (var d = 0; d < u.length; d++) {
                  var p = u[d].name,
                    f = u[d].constructor(e.Services[p])
                  f &&
                    ((s.services[p] = f),
                    f.getDirectInterface &&
                      f.getDirectInterface() &&
                      (r.Services = o.mergeObjects(
                        r.Services,
                        f.getDirectInterface()
                      )))
                }
                for (var l, g = e.Layers.length - 1; g >= 0; g--) {
                  var m = e.Layers[g].layerId,
                    y = c[m](e.Layers[g].configs)
                  y.getDirectInterface() &&
                    (r.Layers = o.mergeObjects(
                      r.Layers,
                      y.getDirectInterface()
                    )),
                    l && y.setNext(l.execute),
                    (l = y)
                }
              })(),
              { getDirectInterface: t }
            )
          }
          var i = e(11),
            a = e(15),
            s = e(36),
            o = e(20),
            u =
              (e(21),
              [
                { name: 'EventsService', constructor: e(30) },
                { name: 'GptService', constructor: e(33) },
                { name: 'TimerService', constructor: e(34) },
                { name: 'ComplianceService', constructor: e(29) },
                { name: 'RenderService', constructor: e(32) },
                { name: 'KeyValueService', constructor: e(31) }
              ]),
            c = {
              PartnersLayer: e(4),
              DirectBiddingLayer: e(1),
              IdentityLayer: e(2)
            }
          t.exports = n
        },
        {}
      ],
      23: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e) {
              var t,
                r = '0'
              y = { source: m, uids: [] }
              for (var n in e)
                e.hasOwnProperty(n) &&
                  ('TDID' === n && (t = e[n]),
                  'TDID_LOOKUP' === n && (r = 'TRUE' === e[n] ? '1' : '0'),
                  y.uids.push({ id: e[n], ext: { rtiPartner: n } }))
              t && (h = t + ',' + r)
            }
            function r() {
              return f.statsId
            }
            function n() {
              return y
            }
            function d() {
              var e = {}
              return h && (e[f.targetingKeys.exchangeBidding] = h), e
            }
            function p() {
              return new u(function(e) {
                var r = s.getData(v)
                if (r) {
                  i.emit('hs_identity_cached', { statsId: f.statsId })
                  var n
                  return (
                    'match' === r.response
                      ? ((n = 'hs_identity_response'), t(r.data))
                      : (n =
                          'pass' === r.response
                            ? 'hs_identity_pass'
                            : 'hs_identity_error'),
                    i.emit(n, { statsId: f.statsId }),
                    void e()
                  )
                }
                i.emit('hs_identity_request', { statsId: f.statsId }),
                  o.ajax({
                    url: l,
                    data: { ttd_pid: 'casale', fmt: 'json', p: g },
                    method: 'GET',
                    withCredentials: !0,
                    onSuccess: function(r) {
                      var n
                      try {
                        n = JSON.parse(r)
                      } catch (t) {
                        return (
                          i.emit('hs_identity_error', { statsId: f.statsId }),
                          s.setData(
                            v,
                            {
                              response: 'error'
                            },
                            f.features.identityDataExpiry.error
                          ),
                          void e()
                        )
                      }
                      if (!n.hasOwnProperty('TDID'))
                        return (
                          i.emit('hs_identity_error', { statsId: f.statsId }),
                          s.setData(
                            v,
                            { response: 'error' },
                            f.features.identityDataExpiry.error
                          ),
                          void e()
                        )
                      i.emit('hs_identity_response', { statsId: f.statsId }),
                        t(n),
                        s.setData(
                          v,
                          { response: 'match', data: n },
                          f.features.identityDataExpiry.match
                        ),
                        e()
                    },
                    onFailure: function(t) {
                      i.emit('hs_identity_error', { statsId: f.statsId }),
                        s.setData(
                          v,
                          { response: 'error' },
                          f.features.identityDataExpiry.error
                        ),
                        e()
                    }
                  })
              })
            }
            if (!o.isXhrSupported()) return null
            var f, l, g, m, y, v, h
            return (
              (function() {
                ;(i = c.services.EventsService),
                  (f = {
                    partnerId: 'AdserverOrgIp',
                    statsId: 'ADSORG',
                    version: '1.2.0',
                    features: {
                      identityDataExpiry: {
                        match: 6048e5,
                        pass: 864e5,
                        error: 864e5
                      }
                    },
                    targetingKeys: { exchangeBidding: 'ixpid_1' }
                  }),
                  (l = a.getProtocol() + '//match.adsrvr.org/track/rid'),
                  (g = e.publisherId),
                  (m = 'adserver.org'),
                  (v = 'AdserverOrgIp'),
                  (y = null),
                  (h = '')
              })(),
              { getStatsId: r, getResults: n, getTargets: d, retrieve: p }
            )
          }
          var i,
            a = e(6),
            s = e(7),
            o = e(16),
            u = e(13),
            c = e(36)
          e(21)
          t.exports = n
        },
        {}
      ],
      24: [
        function(e, t, r) {
          'use strict'
          function n(e, t) {
            function r(e, t) {
              var r = {
                match: 'hs_identity_response',
                pass: 'hs_identity_pass',
                error: 'hs_identity_error'
              }[e]
              i.emit(r, { statsId: I })
              var n = { response: e, data: t },
                a = h.cacheExpiry[e]
              s.setData(S, n, a),
                i.emit('ip_module_result_' + b, e, t),
                'match' === e && (w = t),
                E && E()
            }
            function n(e) {
              var t = s.getData(e)
              return t && 'match' === t.response && t.data ? t.data : null
            }
            function f(e) {
              var t = {
                url: e.url,
                method: e.method,
                async: !0,
                withCredentials: !0,
                jsonp: !1,
                continueAfterTimeout: !1,
                timeout: e.timeout || 0
              }
              return (
                e.onSuccess && (t.onSuccess = e.onSuccess),
                e.onTimeout && (t.onTimeout = e.onTimeout),
                e.onFailure && (t.onFailure = e.onFailure),
                void 0 !== e.data && (t.data = e.data),
                void 0 !== e.contentType && (t.contentType = e.contentType),
                o.ajax(t)
              )
            }
            function l(e) {
              T = e
            }
            function g() {
              return I
            }
            function m() {
              return w
            }
            function y() {
              if (T) return T
              if (w && p.isArray(w.uids) && w.uids.length && w.uids[0].id) {
                var e = {}
                return (e[h.targetingKeys.exchangeBidding] = w.uids[0].id), e
              }
              return null
            }
            function v() {
              return new u(function(e) {
                E = e
                var t = s.getData(S)
                if (t)
                  return (
                    i.emit('hs_identity_cached', { statsId: I }),
                    void r(t.response, t.data)
                  )
                i.emit('ip_module_retrieve_' + b)
              })
            }
            var h, b, I, _, w, T, E, S
            return (
              (function() {
                ;(i = c.services.EventsService),
                  (h = e.profile),
                  (b = h.partnerId),
                  (I = h.statsId),
                  (w = null),
                  (T = null),
                  (E = null),
                  (S = b),
                  (_ = {
                    Utilities: {
                      buildUrl: o.buildUrl,
                      getPageUrl: a.getPageUrl,
                      getProtocol: a.getProtocol,
                      getReferrer: a.getReferrer,
                      getTime: d.now,
                      getType: p.getType,
                      isArray: p.isArray,
                      isEmpty: p.isEmpty,
                      isFunction: p.isFunction,
                      isInteger: p.isInteger,
                      isNumeric: p.isNumeric,
                      isString: p.isString,
                      isTopFrame: a.isTopFrame,
                      isXhrSupported: o.isXhrSupported,
                      getIdentityResultFrom: n,
                      ajax: f
                    },
                    onRetrieve: i.on.bind(null, 'ip_module_retrieve_' + b),
                    onResult: i.on.bind(null, 'ip_module_result_' + b),
                    registerMatch: r.bind(null, 'match'),
                    registerPass: r.bind(null, 'pass'),
                    registerError: r.bind(null, 'error'),
                    registerEbTargeting: l,
                    configs: t
                  }),
                  e.main(_)
              })(),
              { getStatsId: g, getResults: m, getTargets: y, retrieve: v }
            )
          }
          var i,
            a = e(6),
            s = e(7),
            o = e(16),
            u = e(13),
            c = e(36),
            d = e(19),
            p = e(20)
          t.exports = n
        },
        {}
      ],
      25: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e) {
              v = { source: y, uids: [{ id: e, ext: { rtiPartner: 'idl' } }] }
            }
            function r() {
              return l.statsId
            }
            function n() {
              return v
            }
            function p() {
              var e = {}
              return v && (e[l.targetingKeys.exchangeBidding] = v.uids[0].id), e
            }
            function f() {
              return new u(function(e) {
                var r = s.getData(h)
                if (r) {
                  i.emit('hs_identity_cached', { statsId: l.statsId })
                  var n
                  return (
                    'match' === r.response
                      ? ((n = 'hs_identity_response'), t(r.envelope))
                      : (n =
                          'pass' === r.response
                            ? 'hs_identity_pass'
                            : 'hs_identity_error'),
                    i.emit(n, { statsId: l.statsId }),
                    void e()
                  )
                }
                i.emit('hs_identity_request', { statsId: l.statsId }),
                  o.ajax({
                    url: g,
                    data: { pid: m, rt: 'envelope' },
                    method: 'GET',
                    withCredentials: !0,
                    onSuccess: function(r) {
                      var n
                      try {
                        n = JSON.parse(r)
                      } catch (t) {
                        return (
                          i.emit('hs_identity_error', { statsId: l.statsId }),
                          s.setData(
                            h,
                            { response: 'error' },
                            l.features.identityDataExpiry.error
                          ),
                          void e()
                        )
                      }
                      return d.isEmpty(n)
                        ? (i.emit('hs_identity_pass', { statsId: l.statsId }),
                          s.setData(
                            h,
                            { response: 'pass' },
                            l.features.identityDataExpiry.pass
                          ),
                          void e())
                        : n.hasOwnProperty('envelope')
                        ? d.isEmpty(n.envelope)
                          ? (i.emit('hs_identity_pass', {
                              statsId: l.statsId
                            }),
                            s.setData(
                              h,
                              { response: 'pass' },
                              l.features.identityDataExpiry.pass
                            ),
                            void e())
                          : (i.emit('hs_identity_response', {
                              statsId: l.statsId
                            }),
                            t(n.envelope),
                            s.setData(
                              h,
                              { response: 'match', envelope: n.envelope },
                              l.features.identityDataExpiry.match
                            ),
                            void e())
                        : (i.emit('hs_identity_error', {
                            statsId: l.statsId
                          }),
                          s.setData(
                            h,
                            { response: 'error' },
                            l.features.identityDataExpiry.error
                          ),
                          void e())
                    },
                    onFailure: function(t) {
                      204 === t
                        ? (i.emit('hs_identity_pass', { statsId: l.statsId }),
                          s.setData(
                            h,
                            { response: 'pass' },
                            l.features.identityDataExpiry.pass
                          ))
                        : (i.emit('hs_identity_error', { statsId: l.statsId }),
                          s.setData(
                            h,
                            { response: 'error' },
                            l.features.identityDataExpiry.error
                          )),
                        e()
                    }
                  })
              })
            }
            if (!o.isXhrSupported()) return null
            var l, g, m, y, v, h
            return (
              (function() {
                ;(i = c.services.EventsService),
                  (l = {
                    partnerId: 'LiveRampIp',
                    statsId: 'LVRAMP',
                    version: '1.1.0',
                    features: {
                      identityDataExpiry: {
                        match: 864e5,
                        pass: 864e5,
                        error: 864e5
                      }
                    },
                    targetingKeys: { exchangeBidding: 'ixpid_3' }
                  }),
                  (g = a.getProtocol() + '//api.rlcdn.com/api/identity'),
                  (m = 2),
                  (y = 'liveramp.com'),
                  (h = 'LiveRampIp'),
                  (v = null)
              })(),
              { getStatsId: r, getResults: n, getTargets: p, retrieve: f }
            )
          }
          var i,
            a = e(6),
            s = e(7),
            o = e(16),
            u = e(13),
            c = e(36),
            d = (e(21), e(20))
          t.exports = n
        },
        {}
      ],
      26: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(t) {
              var r = { v: 7.2, s: e.siteId, fn: b },
                n = d.BidRequest(),
                i = o.isTopFrame() ? 1 : 0
              n.setPage(o.getPageUrl()),
                m.isString(document.referrer) &&
                  '' !== document.referrer &&
                  n.setRef(document.referrer),
                n.setExt({ source: 'ixwrapper' })
              for (var a = 0; a < t.length; a++)
                if (t[a].hasOwnProperty('xSlotRef')) {
                  var u = t[a].xSlotRef
                  if (u) {
                    t[a].size = u.size
                    var c = { w: u.size[0], h: u.size[1], topframe: i },
                      p = { sid: t[a].xSlotName, siteID: u.siteId }
                    t[a].ixImpId = n.addImp(c, p, e.bidFloor, e.bidFloorCur)
                  }
                }
              if (t[0].identityData)
                for (var f in t[0].identityData)
                  t[0].identityData.hasOwnProperty(f) &&
                    t[0].identityData[f].data &&
                    n.addUserEid(t[0].identityData[f].data)
              if (s.isPrivacyEnabled()) {
                var l = s.gdpr.getConsent()
                n.setGdprConsent(l.applies, l.consentString)
              }
              return (
                (r.r = n.stringify()),
                { url: h, data: r, callbackId: n.getId() }
              )
            }
            function r(e) {
              try {
                var t = d.BidResponse(e),
                  r = t.getId()
                y._adResponseStore[r] = t
              } catch (e) {
                i.emit(
                  'internal_error',
                  'Error occurred while saving response for "' +
                    v.partnerId +
                    '".',
                  e.stack
                )
              }
            }
            function n(t, r, n, s) {
              var o = r.getExt()
              if (e.hasOwnProperty('asedge') && o && o.akamaiDebugInfo) {
                var u = h.replace(/^https?\:\/\/|\/cygnus/g, ''),
                  d = { sessionId: t, hostname: u }
                void 0 !== o.akamaiDebugInfo.akamaiPresent &&
                  (d.akamaiPresent = o.akamaiDebugInfo.akamaiPresent.toString()),
                  void 0 !== o.akamaiDebugInfo.requestHost &&
                    (d.requestHost = o.akamaiDebugInfo.requestHost.toString()),
                  i.emit('hs_akamai_debug', d)
              }
              for (
                var p = r.getBids(), l = n.slice(), b = 0;
                b < p.length;
                b++
              ) {
                for (var I, _ = l.length - 1; _ >= 0; _--)
                  if (l[_].ixImpId === p[b].impid) {
                    ;(I = l[_]), l.splice(_, 1)
                    break
                  }
                if (I) {
                  var w = I.htSlot.getId()
                  if (
                    p[b].hasOwnProperty('price') ||
                    (p[b].ext && p[b].ext.hasOwnProperty('dealid'))
                  ) {
                    var T = p[b].price
                    v.enabledAnalytics.requestTime &&
                      (i.emit('hs_slot_bid', {
                        sessionId: t,
                        statsId: v.statsId,
                        htSlotId: w,
                        requestId: I.requestId,
                        xSlotNames: [I.xSlotName]
                      }),
                      s[w] &&
                        s[w][I.requestId] &&
                        m.arrayDelete(s[w][I.requestId], I.xSlotName))
                    var E
                    p[b].ext &&
                      m.isString(p[b].ext.dealid) &&
                      !m.isEmpty(p[b].ext.dealid) &&
                      (E = p[b].ext.dealid)
                    var S = p[b].adm
                    ;(I.targetingType = 'slot'), (I.targeting = {})
                    var P = ''
                    ;(I.adm = S),
                      m.isNumeric(T) &&
                        (I.price = Number(y._bidTransformers.price.apply(T))),
                      (P = m.isNumeric(T)
                        ? y._bidTransformers.targeting.apply(T)
                        : T)
                    var O = y._configs.targetingKeys.pm,
                      x = y._configs.targetingKeys.pmid,
                      D = y._configs.targetingKeys.om,
                      R = y._configs.targetingKeys.id
                    if (y._configs.lineItemType !== c.LineItemTypes.CUSTOM) {
                      var A = f.arrayToString(I.size)
                      E
                        ? ((I.targeting[x] = [A + '_' + E]),
                          m.isString(P) &&
                            !m.isEmpty(P) &&
                            (I.targeting[O] = [A + '_' + P]))
                        : (I.targeting[D] = [A + '_' + P]),
                        (I.targeting[R] = [I.requestId])
                      a.registerAd({
                        sessionId: t,
                        partnerId: v.partnerId,
                        adm: S,
                        requestId: I.requestId,
                        size: I.size,
                        price: P,
                        dealId: E,
                        timeOfExpiry: v.features.demandExpiry.enabled
                          ? v.features.demandExpiry.value + g.now()
                          : 0
                      })
                    } else {
                      var N = I.xSlotName
                      E
                        ? ((I.targeting[O] = [N + '_' + E]),
                          m.isString(P) &&
                            !m.isEmpty(P) &&
                            I.targeting[O].push(N + '_' + P))
                        : (I.targeting[D] = [N + '_' + P]),
                        a.registerIndexLegacyAd(
                          t,
                          v.partnerId,
                          S,
                          v.features.demandExpiry.enabled
                            ? v.features.demandExpiry.value + g.now()
                            : 0,
                          E || P,
                          N
                        )
                    }
                  }
                }
              }
              v.enabledAnalytics.requestTime &&
                y._emitStatsEvent(t, 'hs_slot_pass', s)
            }
            var y, v, h, b
            !(function() {
              ;(i = l.services.EventsService),
                (a = l.services.RenderService),
                (s = l.services.ComplianceService),
                (v = {
                  partnerId: 'IndexExchangeHtb',
                  namespace: 'IndexExchangeHtb',
                  statsId: 'INDX',
                  version: '2.4.0',
                  targetingType: 'slot',
                  enabledAnalytics: { requestTime: !0 },
                  features: {
                    demandExpiry: { enabled: !0, value: 45e3 },
                    rateLimiting: { enabled: !1, value: 0 }
                  },
                  targetingKeys: {
                    id: 'ix_id',
                    om: 'IOM',
                    pm: 'IPM',
                    pmid: 'IPMID'
                  },
                  bidUnitInCents: 1,
                  lineItemType: c.LineItemTypes.ID_AND_SIZE,
                  callbackType: p.CallbackTypes.ID,
                  architecture: p.Architectures.FSRA,
                  requestType: p.RequestTypes.ANY
                }),
                (h = e.hasOwnProperty('asedge')
                  ? o.getProtocol('http://ht-lb', 'https://ht-lb-sec') +
                    '.casalemedia.com/cygnus'
                  : o.getProtocol('http://as', 'https://as-sec') +
                    '.casalemedia.com/cygnus'),
                (b = l.NAMESPACE + '.' + v.namespace + '.adResponseCallback'),
                (y = p(v, e, null, {
                  parseResponse: n,
                  generateRequestObj: t,
                  adResponseCallback: r
                })),
                window[l.NAMESPACE] &&
                  ((window[l.NAMESPACE][v.namespace] =
                    window[l.NAMESPACE][v.namespace] || {}),
                  (window[l.NAMESPACE][v.namespace].adResponseCallback = r))
            })()
            var I = {}
            return u.derive(y, I)
          }
          var i,
            a,
            s,
            o = e(6),
            u = e(8),
            c = e(10),
            d = e(17),
            p = e(27),
            f = e(18),
            l = e(36),
            g = e(19),
            m = e(20)
          e(21)
          t.exports = n
        },
        {}
      ],
      27: [
        function(e, t, r) {
          'use strict'
          function n(e, t, r, m) {
            function y(e) {
              return function(t) {
                ;(j[e] = t), delete K[e]
              }
            }
            function v(e, t, r) {
              for (var n in r)
                if (r.hasOwnProperty(n))
                  for (var a in r[n])
                    r[n].hasOwnProperty(a) &&
                      r[n][a].length &&
                      i.emit(t, {
                        sessionId: e,
                        statsId: D.statsId,
                        htSlotId: n,
                        requestId: a,
                        xSlotNames: r[n][a]
                      })
            }
            function h(e, r) {
              var n = {}
              return (
                'price' === e &&
                  (n = {
                    outputCentsDivisor: 1,
                    outputPrecision: 0,
                    roundingType: 'NONE'
                  }),
                g.mergeObjects(
                  q[e],
                  { bidUnitInCents: D.bidUnitInCents },
                  r || {},
                  t.bidTransformer || {},
                  n
                )
              )
            }
            function b(e) {
              var t = []
              D.architecture === n.Architectures.FSRA && t.push([])
              for (var r = {}, i = 0; i < e.length; i++) {
                var a = e[i].htSlot.getName()
                if (z.mapping.hasOwnProperty(a))
                  for (
                    var s = '_' + l.generateUniqueId(), o = 0;
                    o < z.mapping[a].length;
                    o++
                  ) {
                    var u = {},
                      c = z.mapping[a][o]
                    ;(u.partnerId = D.partnerId),
                      (u.partnerStatsId = D.statsId),
                      (u.htSlot = e[i].htSlot),
                      (u.ref = e[i].ref),
                      (u.xSlotRef = z.xSlots[c]),
                      (u.xSlotName = c),
                      (u.requestId = s),
                      e[i].firstPartyData &&
                        (u.firstPartyData = e[i].firstPartyData),
                      e[i].identityData && (u.identityData = e[i].identityData),
                      D.architecture === n.Architectures.MRA
                        ? t.push([u])
                        : D.architecture === n.Architectures.FSRA
                        ? t[0].push(u)
                        : (r.hasOwnProperty(c) || (r[c] = 0),
                          t.length < r[c] + 1 && t.push([]),
                          t[r[c]].push(u),
                          r[c]++)
                  }
              }
              return t
            }
            function I(e, t) {
              if (0 === t.length) return p.resolve([])
              ;(B.keyValues = s.getDefaultKeyValueData()),
                s.hasKeyValueAccess(D.partnerId) &&
                  (B.keyValues = s.getKeyValueData())
              var r = L(t, B)
              if (g.isEmpty(r)) return p.resolve([])
              D.callbackType === n.CallbackTypes.CALLBACK_NAME &&
                (K[r.callbackId] = y(r.callbackId))
              var a = {}
              if (D.enabledAnalytics.requestTime) {
                for (var o = 0; o < t.length; o++) {
                  var u = t[o],
                    c = u.htSlot.getId(),
                    f = u.requestId
                  a.hasOwnProperty(c) || (a[c] = {}),
                    a[c].hasOwnProperty(f) || (a[c][f] = []),
                    a[c][f].push(u.xSlotName)
                }
                v(e, 'hs_slot_request', a)
              }
              return new p(function(s) {
                i.emit('partner_request_sent', { partner: D.partnerId })
                var o,
                  u,
                  c = {
                    url: r.url,
                    data: r.data,
                    method: 'GET',
                    timeout: z.timeout,
                    withCredentials: !0,
                    jsonp: !0,
                    sessionId: e,
                    globalTimeout: !0,
                    continueAfterTimeout: !0,
                    onSuccess: function(u, c, d) {
                      var p,
                        f = 'success'
                      try {
                        D.callbackType === n.CallbackTypes.NONE
                          ? (p = JSON.parse(u))
                          : (u && eval.call(null, u),
                            (p = j[r.callbackId]),
                            delete j[r.callbackId]),
                          (d && !D.parseAfterTimeout) || M(e, p, t, a, o, c, d)
                      } catch (t) {
                        i.emit(
                          'internal_error',
                          D.partnerId + ' error parsing demand: ' + t,
                          t.stack
                        ),
                          (f = 'error'),
                          D.enabledAnalytics.requestTime &&
                            !d &&
                            v(e, 'hs_slot_error', a)
                      }
                      i.emit('partner_request_complete', {
                        sessionId: e,
                        partner: D.partnerId,
                        status: f
                      }),
                        s(t)
                    },
                    onTimeout: function() {
                      i.emit('partner_request_complete', {
                        sessionId: e,
                        partner: D.partnerId,
                        status: 'timeout'
                      }),
                        D.enabledAnalytics.requestTime &&
                          v(e, 'hs_slot_timeout', a),
                        s(t)
                    },
                    onFailure: function() {
                      i.emit('partner_request_complete', {
                        sessionId: e,
                        partner: D.partnerId,
                        status: 'error'
                      }),
                        D.enabledAnalytics.requestTime &&
                          v(e, 'hs_slot_error', a),
                        s(t)
                    }
                  }
                ;(u = r.networkParamOverrides
                  ? g.mergeObjects(c, r.networkParamOverrides)
                  : c),
                  (D.callbackType !== n.CallbackTypes.NONE &&
                    D.requestType !== n.RequestTypes.AJAX) ||
                    (u.jsonp = !1),
                  (o =
                    D.requestType === n.RequestTypes.JSONP
                      ? d.jsonp(u)
                      : d.ajax(u))
              })
            }
            function _(e) {
              U.push(e)
            }
            function w() {
              return R
            }
            function T(e) {
              ;(k = {}), (k[D.namespace] = e)
            }
            function E(e, t) {
              k[D.namespace][e] = t
            }
            function S() {
              return D.partnerId
            }
            function P() {
              return k
            }
            function O() {
              return (
                D.features.prefetchDisabled &&
                D.features.prefetchDisabled.enabled
              )
            }
            function x(e, t) {
              if (((t = t.slice()), z.rateLimiting.enabled)) {
                var r = l.now()
                if ('page' === D.targetingType) {
                  if (r <= A) return []
                  A = r + z.rateLimiting.value
                } else
                  for (var n = t.length - 1; n >= 0; n--) {
                    var i = t[n].htSlot.getName()
                    N.hasOwnProperty(i) && r <= N[i]
                      ? t.splice(n, 1)
                      : (N[i] = r + z.rateLimiting.value)
                  }
              }
              if (!t.length) return []
              if (C) return C(e, t)
              for (var a = b(t), s = [], o = 0; o < a.length; o++)
                s.push(I(e, a[o]))
              return s
            }
            var D,
              R,
              A,
              N,
              k,
              C,
              L,
              M,
              q,
              z,
              U,
              j,
              F,
              H,
              K,
              B = { keyValues: {} }
            return (
              (function() {
                if (
                  ((i = f.services.EventsService),
                  (a = f.services.RenderService),
                  (s = f.services.KeyValueService),
                  (q = {
                    targeting: {
                      bidUnitInCents: 1,
                      outputCentsDivisor: 1,
                      outputPrecision: 0,
                      roundingType: 'FLOOR',
                      floor: 0,
                      buckets: [{ max: 2e3, step: 5 }, { max: 5e3, step: 100 }]
                    },
                    price: { bidUnitInCents: 1 }
                  }),
                  (D = e),
                  (A = 0),
                  (N = {}),
                  (U = []),
                  (K = {}),
                  (j = {}),
                  (z = {
                    timeout: 0,
                    lineItemType: e.lineItemType,
                    targetingKeys: e.targetingKeys,
                    rateLimiting: e.features.rateLimiting
                  }),
                  t.hasOwnProperty('timeout') &&
                    t.timeout > 0 &&
                    ((z.timeout = t.timeout),
                    i.emit('hs_define_partner_timeout', {
                      timeout: z.timeout,
                      statsId: D.statsId
                    })),
                  t.hasOwnProperty('targetingKeyOverride'))
                )
                  for (var l in t.targetingKeyOverride)
                    t.targetingKeyOverride.hasOwnProperty(l) &&
                      z.targetingKeys.hasOwnProperty(l) &&
                      (z.targetingKeys[l] = t.targetingKeyOverride[l])
                if (
                  (t.hasOwnProperty('rateLimiting') &&
                    (t.rateLimiting.hasOwnProperty('enabled') &&
                      (z.rateLimiting.enabled = t.rateLimiting.enabled),
                    t.rateLimiting.value &&
                      (z.rateLimiting.value = t.rateLimiting.value)),
                  t.hasOwnProperty('lineItemType') &&
                    (z.lineItemType = c.LineItemTypes[t.lineItemType]),
                  (z.xSlots = t.xSlots),
                  (z.mapping = t.mapping),
                  (R = !1),
                  r)
                ) {
                  g.isArray(r) || (r = [r])
                  var y = []
                  r.map(function(e) {
                    var t = p.defer()
                    y.push(t.promise),
                      d.jsonp({
                        url: e,
                        onSuccess: function() {
                          t.resolve()
                        }
                      })
                  }),
                    p.all(y).then(function() {
                      ;(R = !0),
                        i.emit('partner_instantiated', {
                          partner: D.partnerId
                        }),
                        (U = u(U))
                    })
                } else
                  i.emit('partner_instantiated', { partner: D.partnerId }),
                    (R = !0)
                a.registerPartner(
                  D.partnerId,
                  z.lineItemType,
                  z.targetingKeys.id
                ),
                  (F = {}),
                  e.hasOwnProperty('bidUnitInCents') &&
                    ((F.targeting = o(h('targeting'))),
                    (F.price = o(h('price')))),
                  m.retriever
                    ? (C = m.retriever)
                    : ((M = m.parseResponse),
                      (L = m.generateRequestObj),
                      (H = m.adResponseCallback)),
                  (k = {}),
                  k.hasOwnProperty(D.namespace) || (k[D.namespace] = {}),
                  D.callbackType === n.CallbackTypes.ID
                    ? (k[D.namespace].adResponseCallback = H)
                    : (k[D.namespace].adResponseCallbacks = K)
              })(),
              {
                _configs: z,
                _adResponseStore: j,
                _bidTransformers: F,
                _setDirectInterface: T,
                _addToDirectInterface: E,
                _generateReturnParcels: b,
                _emitStatsEvent: v,
                _pushToCommandQueue: _,
                _generateBidTransformerConfig: h,
                getPartnerId: S,
                getDirectInterface: P,
                getPrefetchDisabled: O,
                isReady: w,
                retrieve: x
              }
            )
          }
          var i,
            a,
            s,
            o = e(5),
            u = e(9),
            c = e(10),
            d = e(16),
            p = e(13),
            f = e(36),
            l = e(19),
            g = e(20)
          e(21)
          ;(n.Architectures = { MRA: 0, SRA: 1, FSRA: 2 }),
            (n.CallbackTypes = { ID: 0, CALLBACK_NAME: 1, NONE: 2 }),
            (n.RequestTypes = { ANY: 0, AJAX: 1, JSONP: 2 }),
            (t.exports = n)
        },
        {}
      ],
      28: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(t) {
              var r = { v: 7.2, s: e.siteId.toString(), fn: b },
                n = d.BidRequest(),
                i = o.isTopFrame() ? 1 : 0
              n.setPage(o.getPageUrl()),
                m.isString(document.referrer) &&
                  '' !== document.referrer &&
                  n.setRef(document.referrer),
                n.setExt({ source: 'ixwrapper' })
              for (var a = 0; a < t.length; a++)
                if (t[a].hasOwnProperty('xSlotRef')) {
                  var u = t[a].xSlotRef
                  if (u) {
                    t[a].size = u.sizes[0]
                    var c = { w: u.sizes[0][0], h: u.sizes[0][1], topframe: i },
                      p = { sid: t[a].xSlotName, siteID: u.siteId.toString() }
                    t[a].ixImpId = n.addImp(c, p, e.bidFloor, e.bidFloorCur)
                  }
                }
              if (!t[0].identityData) return {}
              if (
                !t[0].identityData.LiveRampIp ||
                !t[0].identityData.LiveRampIp.data
              )
                return {}
              for (var f in t[0].identityData)
                t[0].identityData.hasOwnProperty(f) &&
                  t[0].identityData[f].data &&
                  n.addUserEid(t[0].identityData[f].data)
              if (s.isPrivacyEnabled()) {
                var l = s.gdpr.getConsent()
                n.setGdprConsent(l.applies, l.consentString)
              }
              return (
                (r.r = n.stringify()),
                { url: h, data: r, callbackId: n.getId() }
              )
            }
            function r(e) {
              try {
                var t = d.BidResponse(e),
                  r = t.getId()
                y._adResponseStore[r] = t
              } catch (e) {
                i.emit(
                  'internal_error',
                  'Error occurred while saving response for "' +
                    v.partnerId +
                    '".',
                  e.stack
                )
              }
            }
            function n(t, r, n, s) {
              var o = r.getExt()
              if (e.hasOwnProperty('asedge') && o && o.akamaiDebugInfo) {
                var u = h.replace(/^https?:\/\/|\/cygnus/g, ''),
                  c = { sessionId: t, hostname: u }
                void 0 !== o.akamaiDebugInfo.akamaiPresent &&
                  (c.akamaiPresent = o.akamaiDebugInfo.akamaiPresent.toString()),
                  void 0 !== o.akamaiDebugInfo.requestHost &&
                    (c.requestHost = o.akamaiDebugInfo.requestHost.toString()),
                  i.emit('hs_akamai_debug', c)
              }
              for (
                var d = r.getBids(), p = n.slice(), l = 0;
                l < d.length;
                l++
              ) {
                for (var b, I = p.length - 1; I >= 0; I--)
                  if (p[I].ixImpId === d[l].impid) {
                    ;(b = p[I]), p.splice(I, 1)
                    break
                  }
                if (b) {
                  var _ = b.htSlot.getId()
                  if (
                    d[l].hasOwnProperty('price') ||
                    (d[l].ext && d[l].ext.hasOwnProperty('dealid'))
                  ) {
                    var w = d[l].price
                    v.enabledAnalytics.requestTime &&
                      (i.emit('hs_slot_bid', {
                        sessionId: t,
                        statsId: v.statsId,
                        htSlotId: _,
                        requestId: b.requestId,
                        xSlotNames: [b.xSlotName]
                      }),
                      s[_] &&
                        s[_][b.requestId] &&
                        m.arrayDelete(s[_][b.requestId], b.xSlotName))
                    var T
                    d[l].ext &&
                      m.isString(d[l].ext.dealid) &&
                      !m.isEmpty(d[l].ext.dealid) &&
                      (T = d[l].ext.dealid)
                    var E = d[l].adm
                    ;(b.targetingType = 'slot'), (b.targeting = {})
                    var S = ''
                    ;(b.adm = E),
                      m.isNumeric(w) &&
                        (b.price = Number(y._bidTransformers.price.apply(w))),
                      (S = m.isNumeric(w)
                        ? y._bidTransformers.targeting.apply(w)
                        : w)
                    var P = y._configs.targetingKeys.pm,
                      O = y._configs.targetingKeys.pmid,
                      x = y._configs.targetingKeys.om,
                      D = y._configs.targetingKeys.id,
                      R = f.arrayToString(b.size)
                    T
                      ? ((b.targeting[O] = [R + '_' + T]),
                        m.isString(S) &&
                          !m.isEmpty(S) &&
                          (b.targeting[P] = [R + '_' + S]))
                      : (b.targeting[x] = [R + '_' + S]),
                      (b.targeting[D] = [b.requestId])
                    var A = 0
                    v.features.demandExpiry.enabled &&
                      (A = v.features.demandExpiry.value + g.now())
                    a.registerAd({
                      sessionId: t,
                      partnerId: v.partnerId,
                      adm: E,
                      requestId: b.requestId,
                      size: b.size,
                      price: S,
                      dealId: T,
                      timeOfExpiry: A
                    })
                  }
                }
              }
              v.enabledAnalytics.requestTime &&
                y._emitStatsEvent(t, 'hs_slot_pass', s)
            }
            var y, v, h, b
            !(function() {
              ;(i = l.services.EventsService),
                (a = l.services.RenderService),
                (s = l.services.ComplianceService),
                (v = {
                  partnerId: 'TargetHtb',
                  namespace: 'TargetHtb',
                  statsId: 'TRGT',
                  version: '1.0.0',
                  targetingType: 'slot',
                  enabledAnalytics: { requestTime: !0 },
                  features: {
                    demandExpiry: { enabled: !0, value: 45e3 },
                    rateLimiting: { enabled: !1, value: 0 }
                  },
                  targetingKeys: {
                    id: 'ix_trgt_id',
                    om: 'ix_trgt_om',
                    pm: 'ix_trgt_pm',
                    pmid: 'ix_trgt_dealid'
                  },
                  bidUnitInCents: 1,
                  lineItemType: c.LineItemTypes.ID_AND_SIZE,
                  callbackType: p.CallbackTypes.ID,
                  architecture: p.Architectures.FSRA,
                  requestType: p.RequestTypes.ANY
                }),
                (h = e.hasOwnProperty('asedge')
                  ? o.getProtocol('http://ht-lb', 'https://ht-lb-sec') +
                    '.casalemedia.com/cygnus'
                  : o.getProtocol('http://as', 'https://as-sec') +
                    '.casalemedia.com/cygnus'),
                (b = l.NAMESPACE + '.' + v.namespace + '.adResponseCallback'),
                (y = p(v, e, null, {
                  parseResponse: n,
                  generateRequestObj: t,
                  adResponseCallback: r
                })),
                window[l.NAMESPACE] &&
                  ((window[l.NAMESPACE][v.namespace] =
                    window[l.NAMESPACE][v.namespace] || {}),
                  (window[l.NAMESPACE][v.namespace].adResponseCallback = r))
            })()
            var I = {}
            return u.derive(y, I)
          }
          var i,
            a,
            s,
            o = e(6),
            u = e(8),
            c = e(10),
            d = e(17),
            p = e(27),
            f = e(18),
            l = e(36),
            g = e(19),
            m = e(20)
          e(21)
          t.exports = n
        },
        {}
      ],
      29: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e) {
              e.hasOwnProperty('gdprApplies') &&
              'boolean' === c.getType(e.gdprApplies)
                ? (b = e.gdprApplies)
                : e.hasOwnProperty('isUserInEu') &&
                  'boolean' === c.getType(e.isUserInEu) &&
                  (b = e.isUserInEu),
                e.hasOwnProperty('consentData') &&
                  'string' === c.getType(e.consentData) &&
                  (I = e.consentData)
            }
            function r(e) {
              if (!x) {
                var r = c.getType(e)
                'undefined' !== r &&
                  ((x = !0),
                  'string' === r ? (I = e) : 'object' === r && t(e),
                  S.resolve())
              }
            }
            function n(e, t) {
              return function() {
                if (e)
                  try {
                    window.__cmp('getConsentData', null, r)
                  } catch (e) {}
                if (t)
                  try {
                    O(r)
                  } catch (e) {}
              }
            }
            function p(e) {
              try {
                var t
                if (
                  ((t =
                    'string' === c.getType(e.data)
                      ? JSON.parse(e.data)
                      : e.data),
                  !t.hasOwnProperty('__cmpReturn') ||
                    'object' !== c.getType(t.__cmpReturn))
                )
                  return
                var n = t.__cmpReturn
                n.callId === D &&
                  (r(n.returnValue, n.success),
                  window.removeEventListener('message', p, !1))
              } catch (e) {}
            }
            function f(e) {
              b = e
            }
            function l() {
              return { applies: b, consentString: I }
            }
            function g() {
              return !0
            }
            function m(e) {
              return function() {
                w !== T.COMPLETE && P && d.startTimer(P)
                var t = arguments
                _.push(function() {
                  e.apply(null, t)
                })
              }
            }
            function y() {
              if (w === T.NOT_STARTED) {
                ;(S = s.defer()),
                  (w = T.IN_PROGRESS),
                  S.promise.then(function() {
                    ;(_ = a(_)), (w = T.COMPLETE)
                  })
                var e = !1,
                  t = !1,
                  r = !1
                if (
                  (window.__cmp &&
                    'function' === c.getType(window.__cmp) &&
                    (t = !0),
                  O && (r = !0),
                  t || r)
                ) {
                  e = !0
                  var o = n(t, r)
                  if ((o(), E > 0)) {
                    var f = window.setInterval(o, h)
                    S.promise.then(function() {
                      window.clearInterval(f)
                    })
                  }
                } else {
                  var l = i.traverseContextTree(function(e) {
                    return e.__cmpLocator ? e : null
                  })
                  if (l) {
                    ;(e = !0), (D = u.generateUniqueId())
                    var g = {
                      __cmpCall: {
                        command: 'getConsentData',
                        parameter: null,
                        callId: D
                      }
                    }
                    window.addEventListener('message', p, !1),
                      l.postMessage(JSON.stringify(g), '*'),
                      l.postMessage(g, '*')
                  }
                }
                if (!e) return void S.resolve()
                0 === E
                  ? S.resolve()
                  : P ||
                    (P = d.createTimer(E, !1, function() {
                      S.resolve()
                    }))
              }
            }
            function v() {
              return (
                w === T.NOT_STARTED && y(),
                w !== T.COMPLETE && P && d.startTimer(P),
                S.promise
              )
            }
            var h = 250,
              b,
              I,
              _,
              w,
              T = { NOT_STARTED: 0, IN_PROGRESS: 1, COMPLETE: 2 },
              E,
              S,
              P,
              O,
              x,
              D = 0
            return (
              (function t() {
                if (
                  ((d = o.services.TimerService),
                  (b = e.gdprAppliesDefault),
                  (I = ''),
                  (_ = []),
                  (E = e.timeout),
                  (w = T.NOT_STARTED),
                  (x = !1),
                  e.customFn)
                )
                  try {
                    ;(O = eval(e.customFn)),
                      'function' !== c.getType(O) && (O = null)
                  } catch (e) {
                    O = null
                  }
                else O = null
                y()
              })(),
              {
                gdpr: { getConsent: l, setApplies: f },
                isPrivacyEnabled: g,
                delay: m,
                wait: v
              }
            )
          }
          var i = e(6),
            a = e(9),
            s = e(13),
            o = e(36),
            u = e(19),
            c = e(20),
            d
          t.exports = n
        },
        {}
      ],
      30: [
        function(e, t, r) {
          'use strict'
          function n() {
            function e(e, t, r) {
              s.hasOwnProperty(e) || (s[e] = [])
              var n = i.generateUniqueId()
              return s[e].push({ id: n, fn: r, once: t }), n
            }
            function t(t, r) {
              return e(t, !1, r)
            }
            function r(t, r) {
              return e(t, !0, r)
            }
            function n(e) {
              for (var t in s)
                if (s.hasOwnProperty(t))
                  for (var r = s[t].length - 1; r >= 0; r--)
                    if (s[t][r].id === e) return void s[t].splice(r, 1)
            }
            function a() {
              var e = Array.prototype.slice.call(arguments),
                t = e.shift()
              if (t && s.hasOwnProperty(t))
                for (var r = s[t].length - 1; r >= 0; r--) {
                  try {
                    s[t][r].fn.apply(null, e)
                  } catch (e) {}
                  s[t][r].once && s[t].splice(r, 1)
                }
            }
            var s
            return (
              (function() {
                s = {}
              })(),
              { on: t, once: r, off: n, emit: a }
            )
          }
          var i = e(19)
          e(21)
          t.exports = n
        },
        {}
      ],
      31: [
        function(e, t, r) {
          'use strict'
          function n() {
            function e(e) {
              return 'object' == typeof e && null !== e && !Array.isArray(e)
            }
            function t() {
              return i.deepCopy(o)
            }
            function r() {
              return i.deepCopy(u)
            }
            function n() {
              return !0
            }
            function a(t) {
              return !!e(t) && ((u.site = i.deepCopy(t)), !0)
            }
            function s(t) {
              return !!e(t) && ((u.user = i.deepCopy(t)), !0)
            }
            var o = { site: {}, user: {} },
              u = {}
            return (
              (function() {
                u = i.deepCopy(o)
              })(),
              {
                getDefaultKeyValueData: t,
                getKeyValueData: r,
                hasKeyValueAccess: n,
                setSiteKeyValueData: a,
                setUserKeyValueData: s
              }
            )
          }
          var i = e(20)
          t.exports = n
        },
        {}
      ],
      32: [
        function(e, t, r) {
          'use strict'
          function n(e) {
            function t(e, t, r, n) {
              if (e.hasOwnProperty(t) && e[t].hasOwnProperty(r)) {
                for (var i = null, a = 0; a < n.length; a++) {
                  var s = n[a]
                  e[t][r].hasOwnProperty(s) && (i = e[t][r][s])
                }
                return i
              }
            }
            function r(e) {
              return !!_.hasOwnProperty(e) && ((w[e] = !0), delete _[e], !0)
            }
            function n() {
              var e = u.now()
              for (var t in _)
                _.hasOwnProperty(t) &&
                  _[t].timeOfExpiry &&
                  e > _[t].timeOfExpiry &&
                  r(t)
            }
            function p(e) {
              var t
              do {
                t = u.generateUniqueId(a.PUBKIT_AD_ID_LENGTH, 'ALPHANUM')
              } while (_.hasOwnProperty[t])
              return (_[t] = e), t
            }
            function f(e) {
              if (
                (_.hasOwnProperty(e) &&
                  _[e].timeOfExpiry &&
                  u.now() > _[e].timeOfExpiry &&
                  r(e),
                w[e])
              )
                return (
                  i.emit(
                    'internal_info',
                    'Attempted to render expired ad ' + e
                  ),
                  null
                )
              if (!_.hasOwnProperty(e))
                throw d(
                  'INVALID_VALUE',
                  '`pubKitAdId` does not match any registered ad'
                )
              var t = _[e]
              return r(e), t
            }
            function l(e) {
              if (e.auxFn)
                try {
                  e.auxFn.apply(null, e.auxArgs)
                } catch (e) {
                  i.emit(
                    'internal_error',
                    'Error occurred running ad aux function.',
                    e.stack
                  )
                }
            }
            function g(e, t) {
              var r = f(t)
              if (!r) return !1
              l(r)
              try {
                u.documentWrite(e, r.adm)
              } catch (e) {
                return (
                  i.emit(
                    'internal_error',
                    'Error occurred while rendering ad "' + t + '".',
                    e.stack
                  ),
                  !1
                )
              }
              return !0
            }
            function m(e) {
              var t = p(e)
              if (e.price || e.dealId) {
                var r = e.partnerId,
                  n = e.requestId
                if (S.hasOwnProperty(r)) {
                  var i
                  ;(i = c.isString(e.size) ? e.size : s.arrayToString(e.size)),
                    s.isSpecialSize(i) && (R[n] = i),
                    P[r] || (P[r] = {}),
                    P[r][i] || (P[r][i] = {}),
                    P[r][i][n] || (P[r][i][n] = []),
                    P[r][i][n].push(t)
                  var a = e.price
                  a &&
                    (O[r] || (O[r] = {}),
                    O[r][a] || (O[r][a] = {}),
                    O[r][a][n] || (O[r][a][n] = []),
                    O[r][a][n].push(t))
                  var o = e.dealId
                  return (
                    o &&
                      (x[r] || (x[r] = {}),
                      x[r][o] || (x[r][o] = {}),
                      x[r][o][n] || (x[r][o][n] = []),
                      x[r][o][n].push(t)),
                    t
                  )
                }
              }
            }
            function y(e, t, r, n, i, a) {
              if (S.hasOwnProperty(t)) {
                var s = { sessionId: e, partnerId: t, adm: r, price: i }
                n && n > 0 && (s.timeOfExpiry = n)
                var o = p(s)
                return (
                  (D[a] = D[a] || {}),
                  (D[a][i] = D[a][i] || []),
                  D[a][i].push(o),
                  o
                )
              }
            }
            function v(e, t, r, n, a) {
              try {
                if (!P.hasOwnProperty(e))
                  return void i.emit(
                    'internal_error',
                    'Partner ' + e + ' missing from ad ID map.'
                  )
                if (!c.isObject(r))
                  return void i.emit('internal_error', 'invalid targeting map')
                if (!r.hasOwnProperty(S[e].idKey))
                  return void i.emit(
                    'internal_error',
                    'targeting map missing key ' + S[e].idKey
                  )
                var s = r[S[e].idKey]
                if (!c.isArray(s))
                  return void i.emit('internal_error', 'invalid targeting map')
                if (!c.isNumeric(n))
                  return void i.emit('internal_error', 'invalid width')
                if (!c.isNumeric(a))
                  return void i.emit('internal_error', 'invalid height')
                var o = n + 'x' + a
                if (E && E.hasOwnProperty(o)) {
                  var u = E[o]
                  o = u[0] + 'x' + u[1]
                }
                for (var d = 0; d < s.length; d++) {
                  var p = s[d],
                    f = R[p] || o
                  if (!P[e].hasOwnProperty(f))
                    return void i.emit(
                      'internal_error',
                      'Size key ' +
                        f +
                        ' missing from ad ID map for partner ' +
                        e
                    )
                  if (P[e][f].hasOwnProperty(p)) {
                    var l = P[e][f][p]
                    if (l.length) {
                      g(t, c.randomSplice(l))
                      break
                    }
                  }
                }
              } catch (t) {
                i.emit(
                  'internal_error',
                  'Error occurred while rendering ad for "' + e + '".',
                  t.stack
                )
              }
            }
            function h(e, r) {
              if (
                void 0 !== e.partner &&
                void 0 !== e.id &&
                void 0 !== e.targeting &&
                (void 0 !== e.size || void 0 !== e.price)
              ) {
                var n = e.partner,
                  a = e.price,
                  o = e.id,
                  u = e.targeting,
                  d = e.size
                if (S[n]) {
                  if (!u.hasOwnProperty(S[n].idKey))
                    return void i.emit(
                      'internal_error',
                      'targeting map missing key ' + S[n].idKey
                    )
                  var p = u[S[n].idKey],
                    g = null
                  if (void 0 !== a)
                    for (
                      var m = [x, O], y = 0;
                      y < m.length && !(g = t(m[y], n, a, p));
                      y++
                    );
                  else {
                    if (!s.isSize(d)) return
                    var v = s.arrayToString(d)
                    if (E && E.hasOwnProperty(v)) {
                      var h = E[v]
                      v = s.arrayToString(h)
                    }
                    g = t(P, n, v, p)
                  }
                  if (g) {
                    var b = c.randomSplice(g),
                      I = f(b)
                    if (!I)
                      return void i.emit(
                        'internal_error',
                        'No ad found for ad ID ' + b
                      )
                    l(I)
                    for (
                      var _,
                        w = I.size,
                        T = I.adm,
                        D = document.getElementsByTagName('iframe'),
                        R = 0;
                      R < D.length;
                      R++
                    )
                      if (D[R].contentWindow === r) {
                        _ = D[R]
                        break
                      }
                    _ &&
                      ((_.width = String(w[0])),
                      (_.height = String(w[1])),
                      '' !== _.parentElement.style.width &&
                        '' !== _.parentElement.style.height &&
                        ((_.parentElement.style.width = w[0] + 'px'),
                        (_.parentElement.style.height = w[1] + 'px'))),
                      r.postMessage(
                        'ix_ht_render_adm:' +
                          JSON.stringify({ adm: T, id: o, size: w }),
                        '*'
                      )
                  }
                }
              }
            }
            function b(e, t, r, n) {
              try {
                for (var a, s = r.split(','), o = 0; o < s.length; o++)
                  if (((a = s[o].split('_')), a[0] === n)) {
                    if (D[n] && D[n][a[1]])
                      for (var u = D[n][a[1]], c = !1; u.length > 0 && !c; )
                        c = g(t, u.shift())
                    return
                  }
              } catch (t) {
                i.emit(
                  'internal_error',
                  'Error occurred while rendering ad for "' + e + '".',
                  t.stack
                )
              }
            }
            function I(e, t, r) {
              S.hasOwnProperty(e) || (S[e] = {}),
                (S[e].lineItemType = t),
                (S[e].idKey = r)
            }
            var _,
              w,
              T,
              E,
              S = {},
              P = {},
              O = {},
              x = {},
              D = {},
              R = {}
            return (
              (function() {
                ;(_ = {}),
                  (w = {}),
                  (E = e.sizeRetargeting || null),
                  (T = setInterval(n, a.RENDER_SERVICE_EXPIRY_SWEEP_TIMER)),
                  (i = o.services.EventsService),
                  window.addEventListener(
                    'message',
                    function(e) {
                      try {
                        if (
                          !c.isString(e.data) ||
                          'ix_ht_render:' !==
                            e.data.substr(0, 'ix_ht_render:'.length)
                        )
                          return
                        h(
                          JSON.parse(e.data.substr('ix_ht_render:'.length)),
                          e.source,
                          e.origin
                        )
                      } catch (e) {
                        i.emit(
                          'internal_error',
                          'Error occurred while rendering ad.',
                          e.stack
                        )
                      }
                    },
                    !1
                  )
              })(),
              {
                registerAd: m,
                render: g,
                registerPartner: I,
                renderDfpAd: v,
                registerIndexLegacyAd: y,
                renderIndexLegacyAd: b
              }
            )
          }
          var i,
            a = e(10),
            s = e(18),
            o = e(36),
            u = e(19),
            c = e(20),
            d = e(21)
          t.exports = n
        },
        {}
      ],
      33: [
        function(e, t, r) {
          'use strict'
          e(19)
          t.exports = function() {
            return {}
          }
        },
        {}
      ],
      34: [
        function(e, t, r) {
          'use strict'
          function n() {
            function e(e) {
              return function() {
                u[e].state = c.TERMINATED
                for (var t = 0; t < u[e].cbs.length; t++)
                  try {
                    u[e].cbs[t]()
                  } catch (e) {}
                delete u[e].cbs, delete u[e].timer
              }
            }
            function t(t, r, n) {
              var s = a.generateUniqueId(i.SESSION_ID_LENGTH)
              return (
                (r = !!r),
                (n = n ? [n] : []),
                (u[s] = { state: c.NEW, cbs: n, timeout: t }),
                r &&
                  ((u[s].state = c.RUNNABLE),
                  (u[s].timer = setTimeout(e(s), t))),
                s
              )
            }
            function r(t) {
              u.hasOwnProperty(t) &&
                u[t].state === c.NEW &&
                ((u[t].state = c.RUNNABLE),
                (u[t].timer = setTimeout(e(t), u[t].timeout)))
            }
            function n(e, t) {
              u.hasOwnProperty(e) &&
                u[e].state !== c.TERMINATED &&
                u[e].cbs.unshift(t)
            }
            function s(e) {
              return u.hasOwnProperty(e) ? u[e].state : null
            }
            function o(e) {
              u.hasOwnProperty(e) &&
                u[e].state !== c.TERMINATED &&
                ((u[e].state = c.TERMINATED),
                clearTimeout(u[e].timer),
                delete u[e].cbs,
                delete u[e].timer)
            }
            var u,
              c = { NEW: 0, RUNNABLE: 1, TERMINATED: 2 }
            return (
              (function() {
                u = {}
              })(),
              {
                TimerStates: c,
                createTimer: t,
                startTimer: r,
                addTimerCallback: n,
                getTimerState: s,
                clearTimer: o
              }
            )
          }
          var i = e(10),
            a = e(19)
          e(21)
          t.exports = n
        },
        {}
      ],
      35: [
        function(e, t, r) {
          'use strict'
          var n,
            i,
            a = (e(6), e(9)),
            s = e(22),
            o = e(36),
            u = e(20)
          ;(window[o.NAMESPACE] = window[o.NAMESPACE] || {}),
            (window[o.NAMESPACE].cmd = window[o.NAMESPACE].cmd || [])
          var c = window[o.NAMESPACE].cmd
          ;(window[o.NAMESPACE] = (function() {
            function e(e) {
              if (!u.isObject(e))
                return void i.emit(
                  'error',
                  'invalid first-party data: `data` must be an object'
                )
              if (e.hasOwnProperty('rubicon')) {
                if (!u.isObject(e.rubicon))
                  return void i.emit(
                    'error',
                    'invalid first-party data.rubicon'
                  )
                for (var t in e.rubicon)
                  if (
                    e.rubicon.hasOwnProperty(t) &&
                    -1 === ['keywords', 'inventory', 'visitor'].indexOf(t)
                  )
                    return void i.emit(
                      'error',
                      'invalid first-party data: unrecognized property ' +
                        t +
                        ' of `data.rubicon`'
                    )
                if (
                  e.rubicon.hasOwnProperty('keywords') &&
                  !u.isArray(e.rubicon.keywords, 'string')
                )
                  return void i.emit(
                    'error',
                    'invalid first-party data: `data.rubicon.keywords` must be an array of strings'
                  )
                if (e.rubicon.hasOwnProperty('inventory')) {
                  if (!u.isObject(e.rubicon.inventory))
                    return void i.emit(
                      'error',
                      'invalid first-party data: `data.rubicon.inventory` must be an object'
                    )
                  for (var r in e.rubicon.inventory)
                    if (
                      e.rubicon.inventory.hasOwnProperty(r) &&
                      !u.isArray(e.rubicon.inventory[r], 'string')
                    )
                      return void i.emit(
                        'error',
                        'invalid first-party data: property ' +
                          r +
                          ' of `data.rubicon.inventory` must be an array of strings'
                      )
                }
                if (e.rubicon.hasOwnProperty('visitor')) {
                  if (!u.isObject(e.rubicon.visitor))
                    return void i.emit(
                      'error',
                      'invalid first-party data: `data.rubicon.visitor` must be an object'
                    )
                  for (var n in e.rubicon.visitor)
                    if (
                      e.rubicon.visitor.hasOwnProperty(n) &&
                      !u.isArray(e.rubicon.visitor[n], 'string')
                    )
                      return void i.emit(
                        'error',
                        'invalid first-party data: property ' +
                          n +
                          ' of `data.rubicon.visitor` must be an array of strings'
                      )
                }
              }
              try {
                f.Layers.PartnersLayer.setFirstPartyData(e)
              } catch (e) {
                i.emit('error', e)
              }
            }
            function t(e, t, r) {
              var n = { sessionId: '' },
                a = ''
              try {
                if (!u.isFunction(t))
                  throw ((a = 'callback must be a function'),
                  i.emit('error', a),
                  new Error(a))
                if (!u.isArray(e, 'object'))
                  return (
                    (a = 'htSlotDemandObjs must be an array of objects'),
                    i.emit('error', a),
                    void t({}, new Error(a))
                  )
                for (var s = 0; s < e.length; s++) {
                  var o = e[s]
                  if (!o.hasOwnProperty('htSlotName'))
                    return (
                      (a =
                        'htSlotDemandObjs[' +
                        s +
                        ']: members must contain the htSlotName property'),
                      i.emit('error', a),
                      void t({}, new Error(a))
                    )
                  if (!u.isString(o.htSlotName))
                    return (
                      (a =
                        'htSlotDemandObjs[' +
                        s +
                        ']: htSlotName must be a string'),
                      i.emit('error', a),
                      void t({}, new Error(a))
                    )
                  if (o.hasOwnProperty('firstPartyData')) {
                    if (!u.isObject(o.firstPartyData))
                      return (
                        (a =
                          'htSlotDemandObjs[' +
                          s +
                          ']: invalid first-party data: `data` must be an object'),
                        i.emit('error', a),
                        void t({}, new Error(a))
                      )
                    if (o.firstPartyData.hasOwnProperty('rubicon')) {
                      var c = o.firstPartyData.rubicon
                      if (!u.isObject(c))
                        return (
                          (a =
                            'htSlotDemandObjs[' +
                            s +
                            ']: invalid rubicon first-party data'),
                          i.emit('error', a),
                          void t({}, new Error(a))
                        )
                      for (var d in c)
                        if (
                          c.hasOwnProperty(d) &&
                          -1 ===
                            [
                              'keywords',
                              'inventory',
                              'visitor',
                              'position'
                            ].indexOf(d)
                        )
                          return (
                            (a =
                              'htSlotDemandObjs[' +
                              s +
                              ']: invalid first-party data: unrecognized property of `firstPartyData.rubicon`'),
                            i.emit('error', a),
                            void t({}, new Error(a))
                          )
                      if (
                        c.hasOwnProperty('keywords') &&
                        !u.isArray(c.keywords, 'string')
                      )
                        return (
                          (a =
                            'htSlotDemandObjs[' +
                            s +
                            ']: invalid first-party data: `firstPartyData.rubicon.keywords` must be an array of strings'),
                          i.emit('error', a),
                          void t({}, new Error(a))
                        )
                      if (!c.hasOwnProperty('inventory')) {
                        if (!u.isObject(c.inventory))
                          return (
                            (a =
                              'htSlotDemandObjs[' +
                              s +
                              ']: invalid first-party data: `firstPartyData.rubicon.inventory` must be an object'),
                            i.emit('error', a),
                            void t({}, new Error(a))
                          )
                        for (var p in c.inventory)
                          if (
                            c.inventory.hasOwnProperty(p) &&
                            !u.isArray(c.inventory[p], 'string')
                          )
                            return (
                              (a =
                                'htSlotDemandObjs[' +
                                s +
                                ']: invalid first-party data: property ' +
                                p +
                                ' of `firstPartyData.rubicon.inventory` must be an array of strings'),
                              i.emit('error', a),
                              void t({}, new Error(a))
                            )
                      }
                      if (c.hasOwnProperty('visitor')) {
                        if (!u.isObject(c.visitor))
                          return (
                            (a =
                              'htSlotDemandObjs[' +
                              s +
                              ']: invalid first-party data: `firstPartyData.rubicon.visitor` must be an object'),
                            i.emit('error', a),
                            void t({}, new Error(a))
                          )
                        for (var l in c.visitor)
                          if (
                            c.visitor.hasOwnProperty(l) &&
                            !u.isArray(c.visitor[l], 'string')
                          )
                            return (
                              (a =
                                'htSlotDemandObjs[' +
                                s +
                                ']: invalid first-party data: property ' +
                                l +
                                ' of `firstPartyData.rubicon.visitor` must be an array of strings'),
                              i.emit('error', a),
                              void t({}, new Error(a))
                            )
                      }
                      if (
                        c.hasOwnProperty('position') &&
                        !u.isString(c.position)
                      )
                        return (
                          (a =
                            'htSlotDemandObjs[' +
                            s +
                            ']: invalid first-party data: `firstPartyData.rubicon.position` must be a string'),
                          i.emit('error', a),
                          void t({}, new Error(a))
                        )
                    }
                  }
                }
                if ('undefined' !== u.getType(r)) {
                  if (!u.isObject(r))
                    return (
                      (a = 'options must be an object'),
                      i.emit('error', a),
                      void t({}, new Error(a))
                    )
                  if (
                    r.hasOwnProperty('timeout') &&
                    (!u.isInteger(r.timeout) || r.timeout < 0)
                  )
                    return (
                      (a = 'options.timeout must be an integer greater than 0'),
                      i.emit('error', a),
                      void t({}, new Error(a))
                    )
                }
                ;(n = f.Layers.DirectBiddingLayer.retrieveDemand(e, r)),
                  n.promise
                    .then(function(e) {
                      t(e)
                    })
                    .catch(function(e) {
                      i.emit('error', e), setTimeout(t.bind(null, {}), 0)
                    })
              } catch (e) {
                i.emit('error', e), setTimeout(t.bind(null, {}), 0)
              }
              return n.sessionId
            }
            function r() {
              var e = m
              return (
                'mobile' === o.DeviceTypeChecker.getDeviceType() && (e = y), e
              )
            }
            function a(e, t, r) {
              var n = ''
              try {
                if (!u.isBoolean(t))
                  return i.emit('error', '`once` must be a boolean'), n
                if (!u.isFunction(r))
                  return i.emit('error', '`callback` must be a function'), n
                if (!u.isString(e))
                  return i.emit('error', '`eventName` must be a string'), n
                if (!v.hasOwnProperty(e))
                  return i.emit('error', 'Unrecognized event ' + e), n
                var a = function() {
                  var t = Array.prototype.slice.call(arguments)
                  r(e, JSON.stringify(t))
                }
                n = t ? i.once(e, a) : i.on(e, a)
              } catch (e) {
                i.emit('error', e)
              }
              return n
            }
            function c(e) {
              try {
                if (!u.isString(e))
                  return void i.emit(
                    'error',
                    '`subscriptionId` must be a string'
                  )
                i.off(e)
              } catch (e) {
                i.emit('error', e)
              }
            }
            function d() {
              var e = {}
              e = f.Layers.IdentityLayer.getIdentityResults()
              for (var t in g) g.hasOwnProperty(t) && delete e[g[t]]
              return e
            }
            var p,
              f,
              l,
              g,
              m,
              y,
              v = {
                error: 1,
                warning: 2,
                global_timeout_reached: 3,
                partner_instantiated: 4,
                partner_request_sent: 5,
                partner_request_complete: 6
              }
            if (
              ((function() {
                try {
                  ;(p = {
                    htSlots: {
                      adhesion_amp: {
                        id: 'e1c4e10c-89bf-0125-25fc-ba0d15c2f900',
                        deviceType: 'desktop',
                        sizeMapping: {
                          '0x0': [[320, 100], [300, 50], [320, 50]]
                        }
                      },
                      adhesion_desktop: {
                        id: '302ccc91-54ec-76c6-45cb-34f794362279',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[728, 90], [970, 90]] }
                      },
                      adhesion_mobile: {
                        id: '80cc7fda-d1b1-5ff7-cc63-f9e5e777f363',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[300, 50], [320, 50]] }
                      },
                      adhesion_tablet: {
                        id: 'd4d78920-1390-a9a9-89cf-55e912b83ddc',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[728, 90]] }
                      },
                      content_amp: {
                        id: '094bfbd8-af76-13f2-b9ed-b35d2db50426',
                        deviceType: 'desktop',
                        sizeMapping: {
                          '0x0': [[320, 100], [320, 50], [300, 50], [300, 250]]
                        }
                      },
                      content_btf: {
                        id: 'a0b74885-85ec-2609-0dc3-5caa29f26a16',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[728, 90], [300, 250]] }
                      },
                      content_mobile: {
                        id: '52366d10-d5b4-49c8-5686-5c476e305b28',
                        deviceType: 'desktop',
                        sizeMapping: {
                          '0x0': [[300, 50], [320, 50], [320, 100], [300, 250]]
                        }
                      },
                      feed_btf: {
                        id: '3a75391b-7e15-4530-46a9-d7b95fcfa6ec',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[728, 90], [300, 250]] }
                      },
                      feed_mobile: {
                        id: '7800e9a3-353d-10e2-81e0-c8bf859dd7c9',
                        deviceType: 'desktop',
                        sizeMapping: {
                          '0x0': [[300, 50], [320, 50], [300, 250]]
                        }
                      },
                      leaderboard_atf: {
                        id: '9199d200-59fe-5044-901c-30b2d5f0a624',
                        deviceType: 'desktop',
                        sizeMapping: {
                          '0x0': [[728, 90], [970, 250], [970, 90]]
                        }
                      },
                      other: {
                        id: 'e30ff5f6-6e9c-a2f1-4b2f-9d1b2e222cb7',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[1, 1], [728, 90]] }
                      },
                      recipe_btf: {
                        id: '2ec889d8-b610-a76f-16b1-2c4d2a83a6da',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[300, 250]] }
                      },
                      recipe_mobile: {
                        id: '1c8ba403-4c90-6364-5242-0d57106025a7',
                        deviceType: 'desktop',
                        sizeMapping: { '0x0': [[300, 250]] }
                      },
                      sidebar_atf: {
                        id: '062f6c8c-6f65-cf2b-bfb1-790398eb1f2d',
                        deviceType: 'desktop',
                        sizeMapping: {
                          '0x0': [
                            [160, 600],
                            [300, 1050],
                            [300, 600],
                            [300, 250]
                          ]
                        }
                      },
                      sidebar_btf: {
                        id: '75b00cb3-e332-de43-f285-4b8bb362e511',
                        deviceType: 'desktop',
                        sizeMapping: {
                          '0x0': [[160, 600], [300, 600], [300, 250]]
                        }
                      }
                    },
                    DeviceTypeChecker: { method: 'USER_AGENT', configs: {} },
                    Services: {
                      TimerService: {},
                      RenderService: { sizeRetargeting: {} },
                      KeyValueService: {},
                      EventsService: {},
                      ComplianceService: { timeout: 0, gdprAppliesDefault: !0 }
                    },
                    Layers: [
                      {
                        layerId: 'DirectBiddingLayer',
                        configs: {
                          desktopGlobalTimeout: 800,
                          mobileGlobalTimeout: 800
                        }
                      },
                      {
                        layerId: 'IdentityLayer',
                        configs: {
                          partners: {
                            AdserverOrgIp: {
                              enabled: !0,
                              configs: { publisherId: 184188 }
                            },
                            LiveRampIp: { enabled: !0, configs: {} }
                          },
                          timeout: 50
                        }
                      },
                      {
                        layerId: 'PartnersLayer',
                        configs: {
                          partners: {
                            IndexExchangeHtb: {
                              enabled: !0,
                              configs: {
                                xSlots: {
                                  other: { siteId: '179864', size: [728, 90] }
                                },
                                mapping: { other: ['other'] },
                                timeout: 0,
                                siteId: '179864',
                                targetingKeyOverride: { om: 'IOM', pm: 'IOM' },
                                bidTransformer: {
                                  outputCentsDivisor: 1,
                                  outputPrecision: 0,
                                  roundingType: 'FLOOR',
                                  floor: 1,
                                  buckets: [{ step: 1, max: 1e4 }],
                                  bidUnitInCents: 1
                                }
                              }
                            },
                            TargetHtb: {
                              enabled: !0,
                              configs: {
                                xSlots: {
                                  1: { siteId: 378681, sizes: [[300, 250]] },
                                  2: { siteId: 378681, sizes: [[300, 50]] },
                                  3: { siteId: 378681, sizes: [[320, 50]] },
                                  4: { siteId: 378681, sizes: [[320, 100]] },
                                  5: { siteId: 378681, sizes: [[728, 90]] },
                                  6: { siteId: 378681, sizes: [[970, 90]] },
                                  7: { siteId: 378681, sizes: [[728, 90]] },
                                  8: { siteId: 378681, sizes: [[300, 50]] },
                                  9: { siteId: 378681, sizes: [[320, 50]] },
                                  10: { siteId: 378681, sizes: [[728, 90]] },
                                  11: { siteId: 378681, sizes: [[300, 250]] },
                                  12: { siteId: 378681, sizes: [[728, 90]] },
                                  13: { siteId: 378681, sizes: [[300, 250]] },
                                  14: { siteId: 378681, sizes: [[300, 250]] },
                                  15: { siteId: 378681, sizes: [[300, 50]] },
                                  16: { siteId: 378681, sizes: [[320, 50]] },
                                  17: { siteId: 378681, sizes: [[728, 90]] },
                                  18: { siteId: 378681, sizes: [[970, 250]] },
                                  19: { siteId: 378681, sizes: [[970, 90]] },
                                  20: { siteId: 378681, sizes: [[300, 250]] },
                                  21: { siteId: 378681, sizes: [[300, 250]] },
                                  22: { siteId: 378681, sizes: [[300, 250]] },
                                  23: { siteId: 378681, sizes: [[160, 600]] },
                                  24: { siteId: 378681, sizes: [[300, 600]] },
                                  25: { siteId: 378681, sizes: [[300, 1050]] },
                                  26: { siteId: 378681, sizes: [[300, 250]] },
                                  27: { siteId: 378681, sizes: [[160, 600]] },
                                  28: { siteId: 378681, sizes: [[300, 600]] }
                                },
                                mapping: {
                                  content_mobile: ['1', '2', '3', '4'],
                                  adhesion_desktop: ['5', '6'],
                                  adhesion_tablet: ['7'],
                                  adhesion_mobile: ['8', '9'],
                                  content_btf: ['10', '11'],
                                  feed_btf: ['12', '13'],
                                  feed_mobile: ['14', '15', '16'],
                                  leaderboard_atf: ['17', '18', '19'],
                                  recipe_btf: ['20'],
                                  recipe_mobile: ['21'],
                                  sidebar_atf: ['22', '23', '24', '25'],
                                  sidebar_btf: ['26', '27', '28']
                                },
                                timeout: 0,
                                siteId: 378681,
                                bidTransformer: {
                                  outputCentsDivisor: 1,
                                  outputPrecision: 0,
                                  roundingType: 'FLOOR',
                                  floor: 1,
                                  buckets: [{ step: 1, max: 1e4 }]
                                }
                              },
                              priority: 200
                            }
                          }
                        }
                      }
                    ]
                  }),
                    (g = []),
                    (m = p.Layers[0].configs.desktopGlobalTimeout),
                    (y = p.Layers[0].configs.mobileGlobalTimeout),
                    (f = s(p).getDirectInterface()),
                    (n = o.services.ComplianceService),
                    (i = o.services.EventsService)
                  try {
                    f.Layers.IdentityLayer.retrieve()
                  } catch (e) {}
                } catch (e) {
                  l = {
                    setFirstPartyData: function() {},
                    retrieveDemand: function(e, t) {
                      return setTimeout(t.bind(null, {}), 0), ''
                    },
                    subscribeEvent: function() {
                      return ''
                    },
                    unsubscribeEvent: function() {}
                  }
                }
              })(),
              l)
            )
              return l
            var h = {}
            if (window[o.NAMESPACE])
              for (var b in window[o.NAMESPACE])
                window[o.NAMESPACE].hasOwnProperty(b) &&
                  (h[b] = window[o.NAMESPACE][b])
            ;(h.setFirstPartyData = e),
              (h.retrieveDemand = n.delay(t)),
              (h.subscribeEvent = a),
              (h.unsubscribeEvent = c),
              (h.getTimeout = r),
              (h.setSiteKeyValueData =
                o.services.KeyValueService.setSiteKeyValueData),
              (h.setUserKeyValueData =
                o.services.KeyValueService.setUserKeyValueData),
              (h.getIdentityInfo = d)
            try {
              ;(h.IndexExchangeHtb = {
                render: o.services.RenderService.renderDfpAd.bind(
                  null,
                  'IndexExchangeHtb'
                )
              }),
                (h.IxModule = {
                  render: o.services.RenderService.renderDfpAd.bind(
                    null,
                    'IndexExchangeHtb'
                  )
                }),
                (window.headertag_render = o.services.RenderService.renderIndexLegacyAd.bind(
                  null,
                  'IndexExchangeHtb'
                )),
                f.Layers.PartnersLayer.Partners.IndexExchangeHtb &&
                  ((h.IndexExchangeHtb = h.IndexExchangeHtb || {}),
                  (h.IndexExchangeHtb.adResponseCallback =
                    f.Layers.PartnersLayer.Partners.IndexExchangeHtb.adResponseCallback))
            } catch (e) {}
            try {
              ;(h.TargetHtb = {
                render: o.services.RenderService.renderDfpAd.bind(
                  null,
                  'TargetHtb'
                )
              }),
                f.Layers.PartnersLayer.Partners.TargetHtb &&
                  ((h.TargetHtb = h.TargetHtb || {}),
                  (h.TargetHtb.adResponseCallback =
                    f.Layers.PartnersLayer.Partners.TargetHtb.adResponseCallback))
            } catch (e) {}
            return h
          })()),
            (window[o.NAMESPACE].cmd = a(c))
        },
        {}
      ],
      36: [
        function(e, t, r) {
          'use strict'
          var n = {
            NAMESPACE: 'headertag',
            PRODUCT: 'Universal',
            services: {},
            htSlots: [],
            htSlotsMap: {},
            DeviceTypeChecker: {},
            initQueue: [],
            globalTimeout: null,
            instanceId: null,
            version: '2.15.0'
          }
          t.exports = n
        },
        {}
      ]
    },
    {},
    [35]
  )
}
